{
  "access": {
    "board": {
      "title": "Meine Zugriffe",
      "mapTitle": "Worauf ich zugreifen kann",
      "leads": "Ihre Leitung:",
      "why": "Warum?",
      "hideWhy": "Ausblenden",
      "whyLoading": "Wird geladen…",
      "whyError": "Konnte nicht geladen werden.",
      "requestsTitle": "Meine Anfragen",
      "requestedRole": "Angefragt: {{role}}",
      "cancel": "Zurückziehen",
      "cancelling": "Wird zurückgezogen…",
      "empty": {
        "title": "Noch keine Zugriffe",
        "description": "Ressourcen, auf die Sie zugreifen können, erscheinen hier, sobald sie mit Ihnen oder Ihrem Team geteilt werden."
      },
      "noRequests": {
        "title": "Keine offenen Anfragen",
        "description": "Angefragte Zugriffe erscheinen hier mit ihrem Status."
      },
      "loadError": "Zugriffsübersicht konnte nicht geladen werden.",
      "resourceTypeError": "{{type}} konnte nicht geladen werden — einige Zugriffe werden evtl. nicht angezeigt.",
      "chatPlaceholder": "Frag zu deinem Zugriff…"
    },
    "openAssistant": "Assistenten für Meine Zugriffe öffnen",
    "team": {
      "title": "Team-Zugriffe",
      "summary": "{{members}} Mitglieder · {{requests}} offene Anfragen",
      "openAssistant": "Assistenten für Team-Zugriffe öffnen",
      "inbox": {
        "title": "Genehmigungen",
        "approve": "Genehmigen",
        "deny": "Ablehnen",
        "deciding": "Wird verarbeitet…",
        "confirmDeny": "Ablehnung senden",
        "cancel": "Abbrechen",
        "denyReasonLabel": "Begründung (optional)",
        "denyReasonPlaceholder": "Warum wird diese Anfrage abgelehnt?",
        "empty": {
          "title": "Posteingang leer",
          "description": "Zugriffsanfragen für Ihr Team erscheinen hier zum Genehmigen oder Ablehnen."
        }
      },
      "composer": {
        "title": "Zugriff erteilen",
        "who": "Wer",
        "whoPlaceholder": "Person oder Rollengruppe wählen",
        "what": "Ressource",
        "whatPlaceholder": "Ressource wählen",
        "role": "Rolle",
        "membersGroup": "Personen",
        "rolesGroup": "Rollengruppen",
        "expiry": "Läuft ab",
        "expiryChoice": {
          "end_of_shift": "Schichtende",
          "permanent": "Unbefristet",
          "until": "Bis…"
        },
        "untilLabel": "Läuft ab am",
        "grant": "Erteilen",
        "granting": "Wird erteilt…",
        "relativeHours": "+{{hours}} Std."
      },
      "roster": {
        "title": "Team-Übersicht",
        "otherGroup": "Weitere",
        "expiringSoon": "Läuft bald ab",
        "grants_one": "Zugriffe",
        "grants_other": "Zugriffe",
        "moreGrants": "+{{count}} weitere",
        "openRequests_one": "{{count}} offene Anfrage",
        "openRequests_other": "{{count}} offene Anfragen",
        "revoke": "Zugriff entziehen",
        "empty": {
          "title": "Keine Teammitglieder",
          "description": "Personen in Ihrem Team erscheinen hier mit ihren Zugriffen."
        }
      },
      "loadError": "Team-Zugriffsboard konnte nicht geladen werden.",
      "chatPlaceholder": "Bitte die Assistenz um einen Zugriffsvorschlag…",
      "switchUnit": "Einheit wechseln",
      "leadOnly": {
        "title": "Nur für Stationsleitungen",
        "description": "Nur die Leitung dieser Einheit sieht das Zugriffs-Board des Teams."
      },
      "notFramed": "Diese Unterhaltung ist noch keiner Einheit zugeordnet."
    },
    "proposal": {
      "action": {
        "grant": "Zugriff erteilen",
        "revoke": "Zugriff entziehen",
        "approve": "Anfrage genehmigen"
      },
      "confirm": {
        "grant": "Erteilen",
        "revoke": "Entziehen",
        "approve": "Genehmigen"
      },
      "confirming": "Wird verarbeitet…",
      "dismiss": "Verwerfen"
    },
    "request": {
      "title": "Kein Zugriff",
      "lockedType": "{{type}} — nicht für Sie freigegeben",
      "canSee": "Sie können weiterhin öffnen",
      "sent": "Anfrage gesendet",
      "alreadyAuthorized": "Sie haben bereits Zugriff",
      "alreadyPending": "Anfrage bereits offen",
      "justificationPlaceholder": "Warum benötigen Sie Zugriff? (optional)",
      "request": "Zugriff anfragen",
      "sending": "Wird gesendet…",
      "addJustification": "Begründung hinzufügen",
      "thisResource": "Dieses Gespräch"
    },
    "explanation": {
      "title": "So erhalten Sie diesen Zugriff"
    },
    "source": {
      "direct": "direkt",
      "group_membership": "über Rolle",
      "org_cascade": "über Einheit",
      "patient_care_team": "über Behandlungsteam",
      "team_supervision": "über Leitung",
      "public": "organisationsweit",
      "admin": "Admin-Freigabe",
      "inherited": "vererbt"
    },
    "role": {
      "viewer": "Betrachter",
      "editor": "Bearbeiter",
      "owner": "Eigentümer",
      "nurse": "Pflegefachperson",
      "shift_coordinator": "Schichtkoordination",
      "therapist": "Therapiefachperson"
    },
    "relation": {
      "member": "Mitglied von",
      "staffs": "im Dienst auf",
      "cares_for": "betreut",
      "covers": "vertritt",
      "shared_with": "direkt geteilt",
      "org_wide": "organisationsweit geteilt",
      "entitled": "berechtigt für",
      "platform_admin": "Plattform-Admin",
      "unit_lead": "Einheitsleitung"
    },
    "resourceType": {
      "patient_one": "Patient",
      "patient_other": "Patienten",
      "session_one": "Sitzung",
      "session_other": "Sitzungen",
      "document_one": "Dokument",
      "document_other": "Dokumente",
      "feature_one": "Funktion",
      "feature_other": "Funktionen",
      "unit_one": "Einheit",
      "unit_other": "Einheiten"
    },
    "locationKind": {
      "hospital": "Spital",
      "building": "Gebäude",
      "ward": "Station",
      "icu": "IPS",
      "bed": "Bett"
    },
    "expiry": {
      "min_one": "in {{count}} Min.",
      "min_other": "in {{count}} Min.",
      "hour_one": "in {{count}} Std.",
      "hour_other": "in {{count}} Std.",
      "day_one": "in {{count}} Tag",
      "day_other": "in {{count}} Tagen",
      "expired": "abgelaufen"
    },
    "status": {
      "pending": "Offen",
      "approved": "Genehmigt",
      "denied": "Abgelehnt",
      "expired": "Abgelaufen",
      "cancelled": "Zurückgezogen"
    },
    "patient": {
      "requestDemographics": "Details anfragen"
    },
    "unitScope": {
      "choose": {
        "title": "Einheit wählen",
        "description": "Sie können mehrere Einheiten verwalten. Wählen Sie die Einheit, mit der Sie arbeiten möchten.",
        "error": "Einheit konnte nicht gesetzt werden. Zum Wiederholen erneut wählen."
      },
      "noAuthority": {
        "title": "Noch keine Einheit",
        "description": "Dieses Board ist für Stationsleitungen. Hinterlegen Sie Ihren Arbeitsort im Profil oder bitten Sie eine Administratorin, Sie als Leitung einer Einheit einzutragen.",
        "descriptionWithUnit": "Dieses Board ist für Stationsleitungen. Sie arbeiten in {{unit}}, sind dort aber noch nicht Leitung — bitten Sie eine Administratorin, Sie als Leitung einzutragen, oder hinterlegen Sie einen anderen Arbeitsort.",
        "setWorkplace": "Arbeitsort festlegen"
      }
    }
  },
  "org": {
    "accessRequests": {
      "title": "Zugriffsanfragen",
      "requestAccess": "Zugriff anfragen",
      "sent": "Anfrage an die verantwortliche Person der Einheit gesendet.",
      "alreadyPending": "Sie haben bereits eine offene Anfrage für diese Einheit.",
      "approve": "Genehmigen",
      "deny": "Ablehnen",
      "alreadyAuthorized": "Sie haben bereits Zugriff."
    },
    "labels": {
      "title": "Labels (optional)",
      "keyPlaceholder": "Schlüssel",
      "valuePlaceholder": "Wert",
      "remove": "Label entfernen",
      "addLabel": "Label hinzufügen"
    },
    "accessLevel": {
      "viewer": "Betrachter",
      "editor": "Bearbeiter",
      "owner": "Eigentümer"
    },
    "location": {
      "editTitle": "Einheit bearbeiten",
      "newTitle": "Neue Einheit",
      "editDesc": "Diese Einheit umbenennen oder ihre Labels anpassen. Art und Platz im Baum ändern sich hier nicht.",
      "newChildDesc": "Eine neue Einheit innerhalb von {{parent}}.",
      "newRootDesc": "Eine neue oberste Einheit (z. B. ein Spital).",
      "kindLabel": "Art",
      "namePlaceholder": "z. B. IPS 2",
      "noKinds": "Keine Arten konfiguriert"
    },
    "move": {
      "title": "{{name}} verschieben",
      "desc": "Eine neue übergeordnete Einheit wählen. Zugriff vererbt sich von oben nach unten – beim Verschieben einer Einheit wandert der gesamte Teilbaum mit.",
      "topLevel": "— Oberste Ebene (kein übergeordnetes Element) —",
      "button": "Verschieben"
    },
    "assign": {
      "title": "Zu {{name}} zuweisen",
      "desc": "Einer Person oder einer ganzen Rolle Zugriff auf diese Einheit geben. Betrachter arbeitet hier · Bearbeiter verwaltet sie · Eigentümer führt sie. Der Zugriff vererbt sich auf jede Untereinheit.",
      "person": "Person",
      "role": "Rolle",
      "selectRole": "Eine Rolle wählen…",
      "accessLevel": "Zugriffsebene",
      "button": "Zuweisen"
    },
    "admit": {
      "title": "Patient in {{name}} aufnehmen",
      "desc": "Einen Patienten zur Aufnahme in diese Einheit wählen. Liegt er bereits in einer anderen Einheit, wird er hierher verlegt."
    },
    "role": {
      "editTitle": "Rolle bearbeiten",
      "newTitle": "Neue Rolle",
      "desc": "Eine Rolle ist eine benannte Gruppe von Personen. Weisen Sie sie Einheiten und Ressourcen zu; ihre Mitglieder erben den Zugriff.",
      "namePlaceholder": "z. B. IPS-Pflege",
      "descLabel": "Beschreibung (optional)",
      "descPlaceholder": "Wofür diese Rolle gedacht ist",
      "selfSelectable": "Beim Onboarding selbst wählbar"
    },
    "roleMember": {
      "title": "Mitglied zu {{name}} hinzufügen",
      "desc": "Alle in dieser Rolle erben ihren Zugriff auf Einheiten und Ressourcen."
    },
    "grant": {
      "title": "Zugriff gewähren · {{name}}",
      "desc": "Allen in dieser Rolle Zugriff auf eine bestimmte Ressource in der gewählten Ebene geben.",
      "resourceTypeLabel": "Ressourcentyp",
      "noResourceTypes": "Keine Ressourcentypen konfiguriert",
      "resourceIdLabel": "Ressourcen-ID",
      "resourceIdPlaceholder": "die ID der Ressource",
      "button": "Gewähren"
    },
    "console": {
      "locations": "Standorte",
      "roles": "Rollen"
    },
    "locationsView": {
      "units": "Einheiten",
      "new": "+ Neu",
      "emptyTitle": "Noch keine Einheiten",
      "emptyHint": "Erstellen Sie Ihr Spital, um den Baum zu starten, und fügen Sie dann Gebäude, Stationen und Betten darin hinzu.",
      "createFirst": "Erste Einheit erstellen",
      "buildOrg": "Bauen Sie Ihre Organisation auf",
      "selectUnit": "Einheit wählen",
      "createFirstHint": "Erstellen Sie links die erste Einheit.",
      "selectUnitHint": "Wählen Sie links eine Einheit, um zu verwalten, wer dort arbeitet und welche Patienten sie umfasst."
    },
    "rolesView": {
      "roles": "Rollen",
      "new": "+ Neu",
      "emptyTitle": "Noch keine Rollen",
      "emptyHint": "Eine Rolle gruppiert Personen nach Funktion – IPS-Pflege, Stationsärzte – sodass Sie den Zugriff einmal pro Rolle vergeben.",
      "createRole": "Eine Rolle erstellen",
      "defineRoles": "Definieren Sie Ihre Rollen",
      "selectRole": "Rolle wählen",
      "createFirstHint": "Erstellen Sie links die erste Rolle.",
      "selectRoleHint": "Wählen Sie eine Rolle, um ihre Mitglieder und ihren Zugriff zu verwalten."
    },
    "ui": {
      "patientCount": "{{count}} Patient",
      "patientCount_other": "{{count}} Patienten",
      "remove": "Entfernen"
    },
    "tree": {
      "collapse": "Einklappen",
      "hiddenParentTitle": "Übergeordnete Einheit liegt ausserhalb Ihres Zugriffs",
      "hiddenParent": "↑ verborgene übergeordnete Einheit",
      "censusContext": "in {{name}} und seinen Untereinheiten",
      "addChild": "Eine Einheit innerhalb von {{name}} hinzufügen"
    },
    "permissions": {
      "adminTier": "Admin-Zugriff (Plattform)",
      "targets": "Bereiche",
      "targetsHint": "Plattform-Befugnisse, jeder Admin-Bereich und jeder Agent, den Sie vergeben können.",
      "noTargets": "Keine vergebbaren Bereiche",
      "noTargetsHint": "Die Plattform stellt keine vergebbaren Admin-Bereiche bereit. Meist ist das Autorisierungsmodell noch nicht konfiguriert.",
      "selectTarget": "Ein Ziel wählen",
      "selectTargetHint": "Wählen Sie links eine Plattform-Befugnis, einen Admin-Bereich oder einen Agenten, um zu sehen, wer darauf zugreifen kann, und Zugriff zu gewähren.",
      "grantAccess": "Zugriff gewähren",
      "whoCanReach": "Wer darauf zugreifen kann",
      "noGrants": "Noch niemandem gewährt",
      "noGrantsHint": "Gewähren Sie einer Person oder Rolle eine der Relationen dieses Ziels.",
      "revokeAdminConfirm": "Vollen Plattform-Admin-Zugriff für „{{label}}“ entfernen?\n\nDas Entziehen des letzten Admins sperrt die Organisation aus der Admin-Oberfläche aus. Nur fortfahren, wenn ein weiterer Admin bleibt.",
      "revoke": "Entziehen",
      "groupPlatform": "Plattform",
      "groupAreas": "Admin-Bereiche",
      "groupAgents": "Agenten",
      "agentRestricted": "Beschränkt — offen nur für die hier Berechtigten",
      "agentOpen": "Für alle offen — eine Vergabe ändert nichts",
      "areaSensitive": "Nutzerübergreifende, personenbezogene Inhalte"
    },
    "roleDetail": {
      "members": "Mitglieder",
      "add": "+ Hinzufügen",
      "noMembers": "Keine Mitglieder",
      "noMembersHint": "Fügen Sie dieser Rolle Personen hinzu; sie erben alles, worauf die Rolle zugreifen kann.",
      "addMember": "Ein Mitglied hinzufügen",
      "accessToResources": "Zugriff auf Ressourcen",
      "grant": "+ Gewähren",
      "noGrants": "Kein Ressourcenzugriff",
      "noGrantsHint": "Gewähren Sie dieser Rolle Zugriff auf eine bestimmte Ressource (ein Dokument, eine Sitzung, eine Einheit …) als Betrachter, Bearbeiter oder Eigentümer.",
      "grantAccess": "Zugriff gewähren",
      "truncated": "Es wird die erste Seite der Gewährungen angezeigt — es gibt weitere.",
      "deleteTitle": "{{name}} löschen?",
      "deleteDesc": "Dies entfernt die Rolle und den Zugriff, den ihre Mitglieder dadurch geerbt haben. Direkt erteilter Zugriff bleibt den Personen erhalten."
    },
    "locationDetail": {
      "tier": {
        "owner": "Eigentümer — führen diese Einheit",
        "editor": "Bearbeiter — verwalten diese Einheit",
        "viewer": "Betrachter — arbeiten in dieser Einheit"
      },
      "whoHasAccess": "Wer Zugriff hat",
      "assign": "+ Zuweisen",
      "noAccess": "Noch niemand zugewiesen",
      "noAccessHint": "Weisen Sie eine Person oder Rolle zu. Betrachter arbeitet hier, Bearbeiter verwaltet sie, Eigentümer führt sie — und der Zugriff vererbt sich auf jede Untereinheit.",
      "assignSomeone": "Jemanden zuweisen",
      "byRole": "Nach Rolle",
      "inherited": "Von übergeordneten Einheiten geerbt",
      "fromSource": "von {{source}}",
      "subtreeStaffing": "Besetzung über Untereinheiten",
      "roleTag": "Rolle",
      "roleMembersError": "Mitglieder dieser Rolle konnten nicht geladen werden",
      "roleMembersLoading": "Mitglieder werden geladen…",
      "roleMembersEmpty": "Noch niemand in dieser Rolle",
      "morePreview": "+{{count}} weitere",
      "roleMemberCount": "{{count}} Person: {{list}}",
      "roleMemberCount_other": "{{count}} Personen: {{list}}",
      "patientsInUnit": "Patienten in dieser Einheit",
      "directlyInUnit": "Direkt in dieser Einheit",
      "rolledUpHint": "Über alle Untereinheiten zusammengefasst. Wählen Sie links eine Untereinheit, um deren Patienten aufzunehmen, zu entlassen oder zu verlegen.",
      "discharge": "Entlassen",
      "admit": "+ Aufnehmen",
      "noPatients": "Keine Patienten hier",
      "noPatientsHint": "Nehmen Sie einen Patienten auf, um ihn in diese Einheit zu legen; hier zugewiesenes Personal sieht ihn automatisch.",
      "admitPatient": "Einen Patienten aufnehmen",
      "labels": "Labels",
      "deleteTitle": "{{name}} löschen?",
      "deleteDesc": "Dies entfernt die Einheit und den dadurch fliessenden Zugriff. Eine Einheit mit Untereinheiten oder aufgenommenen Patienten kann nicht gelöscht werden — verschieben oder entlassen Sie diese zuerst.",
      "schema": {
        "title": "Patientenfelder, die hier erfasst werden",
        "yourView": "Aufgelöst für Ihren eigenen Beruf — ein anderer Beruf erfasst andere Felder.",
        "empty": "Keine Patientenfelder in dieser Einheit",
        "emptyHint": "Die Plattformbasis deklariert für Ihren Beruf keine, und keine Schicht auf dieser Einheit fügt eine hinzu.",
        "readOnly": "Lesbar, nicht schreibbar",
        "layers": "Schichten auf der Kette dieser Einheit",
        "minted": "vom Server erzeugt"
      }
    },
    "patientContext": {
      "title": "Patientenkontext",
      "subtitle": "Was die Plattform auf dieser Station über eine Patientin erfasst und was Agenten hier lesen können.",
      "edit": "Felder der Station bearbeiten",
      "empty": "Für Patientinnen werden hier keine Felder erfasst.",
      "sourcePlatform": "Plattform",
      "sourceOwn": "diese Station",
      "required": "Pflichtfeld",
      "coded": "{{count}} kodiert",
      "editTitle": "Patientenfelder für {{unit}}",
      "editDescription": "Dies sind die Felder, die diese Station ergänzt. Geerbte Felder werden dort bearbeitet, wo sie deklariert wurden.",
      "noOwnFields": "Diese Station ergänzt bisher keine eigenen Felder.",
      "keyPlaceholder": "Feldname, z. B. severity",
      "values": "Erlaubte Werte (kommagetrennt; leer bedeutet Freitext)",
      "classes": "Kontextklassen (kommagetrennt)",
      "codings": "Optionale Terminologie-Kodierung pro Wert. Nur ein gelisteter Wert kann kodiert werden.",
      "addField": "Feld hinzufügen",
      "inheritedNote": "Hier geerbt: {{keys}}",
      "reset": "Von übergeordneter Einheit erben"
    }
  },
  "app": {
    "name": "KI für Pflegende",
    "tagline": "Wissen für die Intensivstation"
  },
  "common": {
    "cancel": "Abbrechen",
    "save": "Speichern",
    "saving": "Speichern...",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "loading": "Laden...",
    "updating": "Wird aktualisiert…",
    "staleData": "Zeigt zwischengespeicherte Daten — Aktualisierung fehlgeschlagen",
    "error": "Ein Fehler ist aufgetreten",
    "back": "Zurück",
    "backHome": "Zurück zur Startseite",
    "returnToMainAgent": "{{brand}}",
    "optional": "optional",
    "expand": "Vergrössern",
    "yes": "Ja",
    "no": "Nein",
    "serverStarting": "Server wird vorbereitet...",
    "submitting": "Wird gesendet…",
    "dismiss": "Schliessen",
    "goBack": "Zurück",
    "create": "Erstellen",
    "add": "Hinzufügen",
    "name": "Name",
    "required": "Pflichtfeld"
  },
  "auth": {
    "login": "Anmelden",
    "register": "Registrieren",
    "createAccount": "Konto erstellen",
    "logout": "Abmelden",
    "email": "E-Mail",
    "password": "Passwort",
    "confirmPassword": "Passwort bestätigen",
    "noAccount": "Noch kein Konto?",
    "hasAccount": "Bereits ein Konto?",
    "loginFailed": "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Eingaben.",
    "registerFailed": "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "registerClosed": "Tricorder befindet sich in einer geschlossenen Vorschau — Konten entstehen nur auf Einladung. Bitten Sie Ihre Teamleitung um eine Einladung.",
    "emailExists": "Diese E-Mail-Adresse ist bereits registriert.",
    "passwordMismatch": "Passwörter stimmen nicht überein",
    "passwordPlaceholder": "Mindestens 8 Zeichen",
    "passwordRepeatPlaceholder": "Passwort wiederholen",
    "error": {
      "sessionExpired": "Sitzung abgelaufen",
      "sessionExpiredDesc": "Ihre Anmeldesitzung ist abgelaufen oder war ungültig. Bitte versuchen Sie es erneut."
    },
    "notice": {
      "alreadyVerified": "Bereits bestätigt",
      "alreadyVerifiedDesc": "Ihre E-Mail-Adresse ist bereits bestätigt. Bitte melden Sie sich an."
    },
    "orEmail": "oder mit E-Mail fortfahren",
    "notVerified": {
      "title": "Bitte bestätigen Sie Ihre E-Mail",
      "description": "Dieses Konto wurde noch nicht bestätigt. Öffnen Sie den Link in der E-Mail, die wir Ihnen gesendet haben.",
      "resend": "Bestätigung erneut senden"
    },
    "verify": {
      "inbox": {
        "title": "Prüfen Sie Ihr Postfach",
        "description": "Wir haben einen Bestätigungslink an die folgende Adresse gesendet. Öffnen Sie ihn, um Ihre Registrierung abzuschliessen.",
        "noEmail": "Keine E-Mail erhalten?",
        "resend": "E-Mail erneut senden",
        "resent": "Gesendet. Prüfen Sie Ihr Postfach erneut."
      },
      "pending": {
        "title": "E-Mail wird bestätigt…",
        "description": "Einen Moment, wir aktivieren Ihr Konto."
      },
      "invalid": {
        "title": "Link ungültig oder abgelaufen",
        "description": "Dieser Bestätigungslink ist nicht mehr gültig. Geben Sie Ihre E-Mail-Adresse ein, um einen neuen zu erhalten.",
        "resend": "Neuen Link senden",
        "resent": "Wenn ein Konto existiert, ist ein neuer Link unterwegs.",
        "backToLogin": "Zurück zur Anmeldung"
      },
      "unavailable": {
        "title": "Bestätigung vorübergehend nicht verfügbar",
        "description": "Wir konnten den Link gerade nicht prüfen. Bitte versuchen Sie es erneut.",
        "retry": "Erneut versuchen"
      },
      "resendFailed": "E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es gleich erneut."
    },
    "continueWithGoogle": "Mit Google fortfahren",
    "emailPlaceholder": "name@spital.ch",
    "passwordDotsPlaceholder": "••••••••",
    "registerClosedTitle": "Konten entstehen auf Einladung",
    "setPassword": {
      "title": "Passwort festlegen",
      "description": "Sie sind über Ihre Einladung hier — wählen Sie ein Passwort, um Ihr Konto zu aktivieren.",
      "submit": "Konto aktivieren",
      "backToLogin": "Zurück zur Anmeldung",
      "invalid": {
        "title": "Dieser Link ist unvollständig",
        "description": "Verwenden Sie den Passwort-Link aus Ihrer Einladungs-E-Mail. Kein Link? Bitten Sie Ihre Teamleitung."
      },
      "expired": "Dieser Link ist nicht mehr gültig.",
      "expiredHint": "Möglicherweise wurde ein neuerer Link gesendet — verwenden Sie die neueste E-Mail oder fragen Sie Ihre Teamleitung.",
      "alreadySet": "Das Passwort ist bereits festgelegt. Melden Sie sich damit an."
    }
  },
  "oauthConsent": {
    "heading": "„{{clientName}}“ verbinden?",
    "unnamedClient": "Unbenannte App",
    "lead": "Sie fordert Zugriff auf Ihr Tricorder-Konto an – als {{email}}.",
    "labelAccess": "Zugriff",
    "labelResource": "Ressource",
    "approve": "Erlauben",
    "deny": "Nicht erlauben",
    "errorTitle": "Verbindung fehlgeschlagen",
    "invalidRequest": "Dieser Verbindungslink ist ungültig oder unvollständig. Starten Sie die Verbindung erneut aus der App.",
    "unknownClient": "Diese App ist bei Tricorder nicht registriert. Starten Sie die Verbindung erneut aus der App.",
    "submitError": "Die Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
    "scopes": {
      "mcp": "Tricorder-Werkzeuge in Ihrem Namen verwenden"
    }
  },
  "home": {
    "title": "Unterhaltungen",
    "admin": "Administration",
    "assistantPrefix": "Digital Assistent",
    "showSidebar": "Seitenleiste einblenden",
    "hideSidebar": "Seitenleiste ausblenden",
    "searchAgents": "Agenten suchen…",
    "noAgentMatch": "Kein Agent gefunden.",
    "search": "Sitzungen durchsuchen...",
    "new": "Neue Frage stellen",
    "loadError": {
      "title": "Sitzungen konnten nicht geladen werden",
      "retry": "Erneut versuchen"
    },
    "myPatients": {
      "empty": {
        "title": "Keine Patient:innen zugewiesen",
        "description": "Schicht starten, um Patient:innen hier zu sehen."
      },
      "noSessions": "Noch keine Gespräche für diese:n Patient:in",
      "loadError": {
        "title": "Patient:innen konnten nicht geladen werden"
      }
    },
    "personal": {
      "empty": {
        "title": "Keine persönlichen Gespräche",
        "description": "Gespräche ohne Patientenbezug erscheinen hier."
      }
    },
    "team": {
      "empty": {
        "title": "Keine Team-Gespräche",
        "description": "Stationsweite Team-Arbeit erscheint hier."
      }
    },
    "previousPatients": {
      "row": "Frühere Patient:innen ({{count}})",
      "title": "Frühere Patient:innen",
      "empty": {
        "title": "Keine früheren Patient:innen",
        "description": "Patient:innen, mit denen Sie gearbeitet haben, erscheinen hier."
      },
      "noSessions": "Keine Gespräche für diese:n Patient:in"
    },
    "scope": {
      "patients": "Patienten",
      "personal": "Persönlich",
      "team": "Team"
    },
    "shift": "Meine Schicht",
    "section": {
      "conversations": "Gespräche"
    },
    "headerAction": {
      "notices": "Hinweise",
      "knowledge": "Wissen"
    },
    "openAgent": "Agent öffnen",
    "newConversation": "Neues Gespräch",
    "launcherFor": "Agent für {{label}} öffnen",
    "noAnswerYet": "Noch keine Antwort",
    "viewSource": "Quelle ansehen",
    "selectConversation": {
      "title": "Konversation auswählen",
      "description": "Wähle ein Gespräch, um Antwort und Quelle zu sehen."
    },
    "launcherPersonal": "Persönliche Agenten öffnen",
    "launcherTeam": "Team-Agenten öffnen",
    "handover": {
      "receivedFrom": "Übergabe von {{name}}",
      "receivedUnknown": "Übergabe",
      "viewRapport": "Übergabe-Rapport ansehen"
    }
  },
  "actions": {
    "retry": "Erneut versuchen",
    "retrying": "Wird wiederholt…",
    "report": "Melden",
    "reported": "Gemeldet",
    "close": "Schliessen",
    "submit": "Absenden",
    "confirm": "Bestätigen",
    "cancel": "Abbrechen"
  },
  "agentic": {
    "pleaseSelect": "Bitte wählen...",
    "continue": "Weiter",
    "noLongerActive": "Nicht mehr aktiv — unten weiterschreiben",
    "validation": {
      "required": "Dieses Feld ist erforderlich",
      "invalidNumber": "Bitte geben Sie eine gültige Zahl ein",
      "minValue": "Wert muss mindestens {{min}} {{unit}} sein",
      "maxValue": "Wert darf höchstens {{max}} {{unit}} sein"
    },
    "submit": "Absenden",
    "protocol": {
      "endOfProtocol": "[Ende des Protokolls]",
      "nameUnavailable": "Protokollname nicht verfügbar",
      "badge": {
        "step": "Schritt",
        "decision": "Entscheidung",
        "observation": "Beobachtung",
        "action": "Aktion",
        "terminal": "Terminal"
      }
    }
  },
  "bookmarks": {
    "notFound": "Lesezeichen nicht gefunden",
    "createError": "Lesezeichen konnte nicht erstellt werden."
  },
  "onboarding": {
    "validation": {
      "assistantNameRequired": "Name ist erforderlich"
    },
    "years": {
      "new": "Neu",
      "1-2": "1-2 Jahre",
      "2-5": "2-5 Jahre",
      "3-5": "3-5 Jahre",
      "5-10": "5-10 Jahre",
      "6-10": "6-10 Jahre",
      "10-20": "10-20 Jahre",
      "20+": "20+ Jahre"
    },
    "specialisations": {
      "icu": "Intensivmedizin (IPS)",
      "anesthesia": "Anästhesie",
      "emergency": "Notfallaufnahme (ZNA)",
      "internal_medicine": "Innere Medizin",
      "surgery_visceral": "Viszeralchirurgie",
      "surgery_vascular": "Gefäss- und Transplantationschirurgie",
      "cardiology": "Kardiologie",
      "neurology": "Neurologie",
      "neurosurgery": "Neurochirurgie",
      "oncology": "Onkologie",
      "pneumology": "Pneumologie",
      "gastroenterology": "Gastroenterologie und Hepatologie",
      "nephrology": "Transplantationsimmunologie und Nephrologie",
      "hematology": "Hämatologie",
      "infectiology": "Infektiologie und Spitalhygiene",
      "endocrinology": "Endokrinologie, Diabetologie und Metabolismus",
      "rheumatology": "Rheumatologie",
      "dermatology": "Dermatologie",
      "ophthalmology": "Augenklinik",
      "ent": "Hals-Nasen-Ohren-Klinik (HNO)",
      "urology": "Urologie",
      "gynecology": "Frauenklinik",
      "midwifery": "Geburtshilfe und Perinatologie",
      "orthopaedics": "Orthopädie und Traumatologie",
      "plastic_surgery": "Plastische, Rekonstruktive und Handchirurgie",
      "thoracic_surgery": "Thoraxchirurgie",
      "spinal_surgery": "Spinale Chirurgie",
      "oral_maxillofacial": "Mund-, Kiefer- und Gesichtschirurgie",
      "radiology": "Radiologie und Nuklearmedizin",
      "radiation_oncology": "Radioonkologie",
      "psychosomatics": "Psychosomatik",
      "clinical_pharmacology": "Klinische Pharmakologie und Toxikologie",
      "palliative_care": "Palliative Care",
      "rehabilitation": "Therapien / Rehabilitation",
      "medical_polyclinic": "Medizinische Poliklinik",
      "surgical_polyclinic": "Chirurgische Poliklinik",
      "other": "Andere"
    },
    "institutions": {
      "usb": "Starfleet Medical"
    },
    "languages": {
      "de": "Deutsch",
      "fr": "Français",
      "en": "English"
    },
    "inputPlaceholder": "Antwort eingeben..."
  },
  "profile": {
    "title": "Profil",
    "name": "Name",
    "role": "Rolle",
    "specialisation": "Fachbereich",
    "institution": "Institution",
    "institutionEmpty": "Keine Institution hinterlegt",
    "unit": "Abteilung/Station",
    "unitEmpty": "Keine Station zugewiesen",
    "wardMemberships": "Zusätzlich von Ihrer Organisation zugewiesen",
    "twinName": "Assistenten-Name",
    "language": "Sprache",
    "save": "Änderungen speichern",
    "logout": "Abmelden",
    "logoutConfirm": "Möchten Sie sich wirklich abmelden?",
    "validation": {
      "nameRequired": "Name ist erforderlich"
    },
    "feedback": {
      "failedDescription": "Bitte versuchen Sie es später erneut."
    },
    "summary": {
      "title": "Wissensprofil",
      "empty": {
        "title": "Noch keine Gespräche",
        "description": "Starten Sie Gespräche mit Ihrem digitalen Kollegen. Ihr Wissensprofil wird automatisch erstellt."
      },
      "topics": "Schwerpunkte",
      "evidence": "Evidenz",
      "generatedAt": "Generiert",
      "regenerate": "Aktualisieren",
      "regenerating": "Generiere...",
      "messageCount": "Nachricht",
      "messageCount_other": "Nachrichten"
    },
    "yearsExperience": "Erfahrung",
    "yearsExperienceValue": "{{count}} Jahre",
    "errors": {
      "summaryGenerationFailed": "Profil konnte nicht generiert werden",
      "saveFailed": "Profil konnte nicht gespeichert werden",
      "orgOptionsLoadFailed": "Organisationsoptionen konnten nicht geladen werden",
      "orgOptionsEmpty": "Noch nichts konfiguriert"
    },
    "narrative": "Meine Praxis",
    "narrativeEmpty": "Sie haben noch nichts über Ihre Praxis geschrieben. Tippen Sie auf Bearbeiten, um es zu ergänzen.",
    "narrativePlaceholder": "Womit arbeiten Sie, und was ist Ihnen dabei wichtig?"
  },
  "chat": {
    "unsupportedBlock": "Nicht unterstützter Inhalt – aktualisieren Sie die App, um ihn anzuzeigen.",
    "retiredAgentNotice": "Dieser Assistent steht nicht mehr zur Verfügung. Das Gespräch und der Verlauf bleiben erhalten – Antworten kommen jetzt vom allgemeinen Assistenten.",
    "placeholder": "Frage eingeben...",
    "attach": "Anhang hinzufügen",
    "send": "Nachricht senden",
    "moreDetails": "Mehr dazu",
    "lessDetails": "Weniger",
    "showSources": "Quellen anzeigen",
    "hideSources": "Quellen verbergen",
    "inboundSummary": {
      "viewFullSession": "Ganze Sitzung ansehen",
      "receiving": "Sitzungszusammenfassung wird empfangen …",
      "loadError": "Zusammenfassung konnte nicht geladen werden.",
      "retry": "Erneut versuchen"
    },
    "streaming": {
      "searching": "Suche läuft",
      "citationsFound": "{{count}} Quelle(n) gefunden"
    },
    "errors": {
      "llmError": "Die KI-Antwort ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "protocolBootstrapFailed": "Das Protokoll konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
      "toolCallError": "Ein Dienst ist vorübergehend nicht verfügbar. Die Antwort basiert auf allgemeinem Wissen.",
      "streamingIncomplete": "Antwort unvollständig. Erneut versuchen?",
      "networkError": "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.",
      "retryButton": "Erneut versuchen",
      "retrying": "Wird wiederholt...",
      "imageAnalysisFailed": "Ich konnte das Bild nicht analysieren. Versuchen Sie, den Medikamentennamen einzutippen.",
      "responseGenerationFailed": "Ich konnte keine Antwort generieren. Bitte versuchen Sie, Ihre Frage anders zu formulieren.",
      "safetyFilterBlocked": "Diese Anfrage wurde durch Sicherheitsrichtlinien blockiert. Bitte formulieren Sie Ihre Frage um.",
      "unreadableFailure": "Dieser Fehlerbericht kann nicht gelesen werden: Er hat nicht die Form, die die Plattform festlegt. Beginnen Sie ein neues Gespräch und melden Sie es Ihrer Plattform-Administration, wenn es wieder geschieht."
    },
    "medication": {
      "defaultQuestion": "Was ist das für ein Medikament?",
      "placeholder": "Frage zum Medikament...",
      "capture": "Medikament fotografieren",
      "imageAlt": "Medikamentenbild"
    },
    "attachment": {
      "takePhoto": "Foto aufnehmen",
      "uploadDocument": "Dokument hochladen",
      "uploadDocumentDescription": "PDF in Dokument-Chat öffnen",
      "invalidImageFormat": "Ungültiges Bildformat. Erlaubt: JPEG, PNG, WebP",
      "invalidPdfFormat": "Bitte wählen Sie eine PDF-Datei aus.",
      "selectImage": "Bild auswählen",
      "selectDocument": "Dokument auswählen",
      "addAttachment": "Anhang hinzufügen",
      "addAttachmentDescription": "Wählen Sie, wie Sie Inhalte an Ihre Nachricht anhängen möchten",
      "removeImage": "Bild entfernen",
      "removeDocument": "Dokument entfernen",
      "processingFailed": "Bildverarbeitung fehlgeschlagen"
    },
    "scrollToBottom": "Zum Neuesten springen",
    "scrollToLatest": "Neueste",
    "turnFailed": "Antwort konnte nicht abgeschlossen werden. Bitte senden Sie Ihre Nachricht erneut.",
    "turnFailedQuota": "Die Plattform hat ihre KI-Anfragen für diese Minute aufgebraucht: Das Minutenkontingent des Modellanbieters teilen sich alle auf der Plattform. Warten Sie eine Minute und senden Sie Ihre Nachricht dann erneut. Wenn das öfter vorkommt, bitten Sie eine Administratorin oder einen Administrator, ein höheres Kontingent zu beantragen.",
    "degradedServices": "Eingeschränkte Ergebnisse – einige Referenzdienste sind vorübergehend nicht verfügbar",
    "uiResourceDropped": "Eine Ressourcenkarte wurde ausgelassen, weil der Server eine zu grosse Antwort zurückgegeben hat.",
    "confirmation": {
      "title": "Bestätigung erforderlich"
    },
    "delegation": {
      "askedBy": "Gefragt von {{agent}}",
      "answeredBy": "Antwort von {{agent}}",
      "openConsult": "Konsultation öffnen",
      "couldNotAnswer": "{{agent}} konnte nicht antworten",
      "seeConsult": "Öffnen Sie die Konsultation, um zu sehen, wo sie stehen geblieben ist."
    },
    "handoff": {
      "genericAgent": "Fachspezialist"
    },
    "conversation": "Gespräch"
  },
  "session": {
    "returnToParent": {
      "label": "Zurück zur Sitzung"
    },
    "shared": "Geteilt",
    "byAuthor": "von {{name}}",
    "newConversation": "Neues Gespräch",
    "patientFrame": {
      "clear": "Patient entfernen",
      "personal": "Persönliche Unterhaltung",
      "shiftsError": "Schichtpatienten konnten nicht geladen werden."
    },
    "empty": "Stellen Sie Ihre erste Frage, um die Unterhaltung zu starten.",
    "loadError": "Sitzung konnte nicht geladen werden.",
    "createError": "Sitzung konnte nicht erstellt werden.",
    "gate": {
      "agentAccessRequired": "Für diesen Assistenten fehlt Ihnen die Freigabe. Bitten Sie eine Admin-Person, ihn Ihnen oder Ihrer Rolle freizugeben.",
      "patientAccessLapsed": "Sie haben keinen Zugriff mehr auf diese:n Patient:in, daher kann kein Gespräch dazu geöffnet werden. Falls die Betreuung weiterhin bei Ihnen liegt, lassen Sie sich die Person von der Stationsleitung erneut zuweisen."
    },
    "renameError": "Umbenennen fehlgeschlagen.",
    "deleteError": "Löschen fehlgeschlagen.",
    "deleteForbidden": "Sie haben keine Berechtigung, diese Sitzung zu löschen.",
    "deleteConnection": "Server nicht erreichbar. Bitte erneut versuchen.",
    "archiveError": "Archivieren fehlgeschlagen.",
    "rename": "Umbenennen",
    "renameTitle": "Sitzung umbenennen",
    "renamePlaceholder": "Neuer Name...",
    "archive": "Archivieren",
    "archiveTitle": "Unterhaltung archivieren?",
    "archiveConfirm": "Die Unterhaltung wird ausgeblendet, aber für Ihr Profil behalten.",
    "delete": {
      "title": "Sitzung löschen?",
      "confirm": "Diese Sitzung und alle Nachrichten werden dauerhaft gelöscht."
    },
    "topics": "Themen",
    "hideTopics": "Themen ausblenden",
    "sharing": {
      "sharedWithYou": "{{name}} hat eine Sitzung mit Ihnen geteilt",
      "shareError": "Sitzung konnte nicht geteilt werden. Bitte erneut versuchen."
    },
    "share": "Unterhaltung teilen",
    "notFound": "Unterhaltung nicht gefunden"
  },
  "promptInspector": {
    "trigger": "Was weiss der Assistent?",
    "title": "Anweisungen des Assistenten",
    "explainer": "Dies sind die Anweisungen, denen der Assistent in dieser Unterhaltung folgt.",
    "dynamic": "Live — wird bei jeder Nachricht mit dem aktuellen Kontext neu erstellt",
    "hash": "ID {{hash}}",
    "loadError": "Anweisungen konnten nicht geladen werden.",
    "copy": "Kopieren",
    "copied": "Kopiert",
    "confidential": "Möglicherweise vertraulich",
    "sensitiveNote": "Kann Patientenkontext enthalten — vertraulich behandeln.",
    "layers": {
      "base": "Plattform- & Sicherheitsregeln",
      "role": "Deine Rolle & dein Aufgabenbereich",
      "session": "Kontext der Sitzung",
      "deployment": "Spitalregeln",
      "patientContext": "Patientenkontext",
      "patientSessions": "Gespräche zum Patienten"
    }
  },
  "source": {
    "pageRange": "Seiten {{start}}-{{end}}",
    "viewOriginal": "Originaldokument anzeigen",
    "viewSource": "Quelle ansehen"
  },
  "bookmark": {
    "enriching": "Wird angereichert",
    "enrichmentFailed": "Anreicherung fehlgeschlagen",
    "enrichmentRetrying": "Wird erneut versucht...",
    "enrichmentRetryingDetail": "Literatursuche wird wiederholt",
    "enrichingDetail": "Lesezeichen wird angereichert...",
    "enrichingSubtitle": "PubMed und Medizindatenbanken werden durchsucht",
    "enrichmentRetryHint": "Klicken Sie auf Wiederholen",
    "studyTitle": "Studien-Lesezeichen",
    "viewChat": "Chat ansehen",
    "savedContent": "Gespeicherter Inhalt",
    "originalSources": "Originalquellen",
    "aiStudySummary": "KI-Studienzusammenfassung",
    "pubmedLiterature": "PubMed-Literatur",
    "medicationInfo": "Medikamenteninformationen",
    "noReferences": "Keine weiteren Referenzen zu diesem Thema gefunden.",
    "pages": "Seiten",
    "relevance": "Relevanz"
  },
  "search": {
    "placeholder": "Sitzungen durchsuchen...",
    "noResults": "Keine Ergebnisse gefunden"
  },
  "documents": {
    "loadError": "Dokument konnte nicht geladen werden.",
    "upload": {
      "title": "Dokument hochladen",
      "backToList": "Zurück zu Dokumenten",
      "fileLabel": "Datei",
      "acceptedTypes": "Erlaubte Typen",
      "selected": "Ausgewählt: {{name}} ({{size}} KB)",
      "titleLabel": "Titel",
      "titlePlaceholder": "z.B. Sepsis-Behandlungsprotokoll 2024",
      "categoryLabel": "Kategorie",
      "scopeLabel": "Sichtbarkeit",
      "scopePrivate": "Privat (nur ich)",
      "scopeDepartment": "Abteilung",
      "scopePublic": "Ganze Organisation",
      "departmentLabel": "Abteilung",
      "departmentPlaceholder": "Abteilung auswählen",
      "departmentNote": "Geteilte Dokumente benötigen Admin-Genehmigung bevor sie durchsuchbar sind",
      "departmentLoading": "Abteilungen werden geladen…",
      "departmentEmpty": "Keine Abteilungen verfügbar",
      "departmentLoadError": "Abteilungen konnten nicht geladen werden. Zum Wiederholen tippen.",
      "uploadButton": "Dokument hochladen",
      "uploading": "Wird hochgeladen...",
      "success": {
        "title": "Upload abgeschlossen",
        "statusLabel": "Status:",
        "chunksProcessed": "{{count}} Chunks verarbeitet",
        "pendingApprovalNotice": "Ihr Dokument wartet auf Admin-Genehmigung. Es wird nach der Genehmigung durchsuchbar sein.",
        "uploadAnother": "Weiteres hochladen",
        "viewDocuments": "Dokumente anzeigen"
      },
      "error": {
        "selectFile": "Bitte wählen Sie eine Datei und geben Sie einen Titel ein",
        "departmentRequired": "Bitte wählen Sie eine Abteilung",
        "unsupportedType": "Nicht unterstützter Dateityp. Bitte laden Sie {{types}} hoch",
        "invalidTitle": "Titel enthält ungültige Zeichen. Bitte entfernen Sie: < > \"",
        "uploadFailed": "Upload fehlgeschlagen",
        "urlRequired": "Bitte eine URL eingeben",
        "httpsOnly": "Nur HTTPS-URLs werden unterstützt",
        "invalidUrl": "Bitte eine gültige URL eingeben (z. B. https://pmc.ncbi.nlm.nih.gov/articles/PMC...)"
      },
      "modeFile": "Datei",
      "modeURL": "URL",
      "urlHint": "PubMed, PMC oder eine beliebige Webseite",
      "urlLabel": "URL",
      "urlPlaceholder": "https://pmc.ncbi.nlm.nih.gov/articles/PMC...",
      "categoryFallback": "Leitlinie"
    },
    "list": {
      "title": "Wissensdatenbank",
      "upload": "Hochladen",
      "empty": {
        "title": "Noch keine Dokumente"
      },
      "backHome": "Zurück zur Startseite",
      "table": {
        "title": "Titel",
        "category": "Kategorie",
        "status": "Status",
        "uploaded": "Hochgeladen",
        "chunks": "Chunks",
        "actions": "Aktionen",
        "visibility": "Sichtbarkeit"
      },
      "delete": {
        "button": "Löschen",
        "confirm": "Dauerhaft löschen?",
        "confirmButton": "Bestätigen",
        "cancel": "Abbrechen",
        "deleting": "Wird gelöscht...",
        "cannotDeleteProcessing": "Kann nicht gelöscht werden während Verarbeitung"
      },
      "pagination": "{{shown}} von {{total}} Dokumenten angezeigt",
      "status": {
        "processing": "Wird verarbeitet",
        "ready": "Bereit",
        "error": "Fehler",
        "partial_error": "Teilweise fehlerhaft",
        "quarantined": "Quarantäne",
        "pending_approval": "Ausstehende Genehmigung",
        "superseded": "Ersetzt",
        "unknown": "Unbekannt",
        "partialErrorAction": "Verarbeitung unvollständig — erscheint möglicherweise nicht in der Protokollsuche. Mit „Wiederholen“ erneut verarbeiten."
      },
      "category": {
        "guideline": "Leitlinie",
        "protocol": "Protokoll",
        "procedure": "Verfahren",
        "policy": "Richtlinie",
        "standard": "Pflegestandard",
        "article": "Artikel",
        "reference": "Referenz",
        "unknown": "Unbekannt"
      },
      "date": {
        "today": "Heute",
        "yesterday": "Gestern",
        "daysAgo": "vor {{count}} Tagen"
      },
      "loadMore": "Mehr laden",
      "visibility": {
        "private": "Privat",
        "organisation": "Organisation",
        "changeError": "Sichtbarkeit konnte nicht geändert werden. Bitte erneut versuchen.",
        "pendingApproval": "{{name}} — Genehmigung ausstehend",
        "sentForApproval": "Zur Genehmigung gesendet an {{names}}",
        "sharedWithYou": "Mit Ihnen geteilt"
      },
      "search": "Dokument suchen...",
      "retry": {
        "title": "Verarbeitung wiederholen",
        "success": "Wiederholung gestartet.",
        "error": "Verarbeitung konnte nicht wiederholt werden. Bitte erneut versuchen.",
        "invalidState": "Dieses Dokument kann nicht mehr wiederholt werden."
      },
      "bulk": {
        "selected": "{{count}} ausgewählt",
        "selectAll": "Alle auswählen",
        "selectRow": "{{title}} auswählen",
        "makeOrganisation": "Organisationsweit machen",
        "makePrivate": "Privat machen",
        "retry": "Wiederholen",
        "delete": "Löschen",
        "clear": "Auswahl aufheben",
        "working": "Wird ausgeführt…",
        "confirmDelete": "{{count}} Dokument(e) löschen? Dies kann nicht rückgängig gemacht werden.",
        "visibilityDone": "{{count}} Dokument(e) aktualisiert.",
        "visibilityPartial": "{{done}} aktualisiert, {{failed}} fehlgeschlagen.",
        "deleteDone": "{{count}} Dokument(e) gelöscht.",
        "deletePartial": "{{done}} gelöscht, {{failed}} fehlgeschlagen.",
        "retryDone": "Wiederholung für {{count}} Dokument(e) gestartet.",
        "retryPartial": "Wiederholung für {{done}} gestartet, {{failed}} fehlgeschlagen.",
        "noRetryable": "Keines der ausgewählten Dokumente kann wiederholt werden.",
        "sentForApproval": "{{count}} zur Genehmigung gesendet.",
        "error": "Die Massenaktion konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut."
      },
      "byOwner": "von {{name}}",
      "searching": "Suche…",
      "searchEmpty": "Keine Treffer. Dokumente in Verarbeitung sind noch nicht durchsuchbar.",
      "extractsHeading": "Kernaussagen",
      "extractPage": "S. {{page}}",
      "extractFromFigure": "aus einer Abbildung",
      "unreadableSource": "{{title}}: Seite(n) {{pages}} konnten nicht gelesen werden — bitte direkt in der Quelle nachschlagen.",
      "extractKind": {
        "dose": "Dosis",
        "unknown": "Unbekannt"
      },
      "share": "Dokument teilen"
    },
    "approvals": {
      "approve": "Genehmigen",
      "reject": "Ablehnen",
      "quorumPending": "Genehmigung erfasst — {{approvals}} von {{quorum}} erforderlich",
      "alreadyDecided": "Diese Anfrage wurde bereits entschieden.",
      "decideError": "Entscheidung konnte nicht gespeichert werden. Bitte erneut versuchen.",
      "loadError": "Ausstehende Genehmigungen konnten nicht geladen werden.",
      "approved": "Genehmigt — die Änderung ist jetzt aktiv.",
      "rejected": "Anfrage abgelehnt.",
      "hasMore": "Weitere Anfragen vorhanden — entscheiden Sie diese, um die restlichen zu laden.",
      "accessGranted": "Zugriff gewährt.",
      "accessDenied": "Anfrage abgelehnt.",
      "deny": "Ablehnen",
      "label": {
        "grantToUser": "{{name}} möchte {{level}}-Zugriff",
        "grantToGroup": "{{title}} mit {{grantee}} teilen",
        "publish": "{{title}} für die Organisation freigeben"
      },
      "signoffsRecorded": "Bisher {{count}} Genehmigung(en) erfasst"
    },
    "sharing": {
      "addTargets": "Teilen mit",
      "target": {
        "people": "Personen",
        "roles": "Rollen",
        "units": "Einheiten"
      },
      "kind": {
        "person": "Person",
        "role": "Rolle",
        "unit": "Einheit"
      },
      "role": {
        "viewer": "Betrachter",
        "editor": "Bearbeiter",
        "owner": "Eigentümer",
        "demographics": "Stammdaten"
      },
      "withAccess": "Wer hat Zugriff",
      "sentForApproval": "Zur Genehmigung gesendet — wird geprüft von {{names}}",
      "sentForApprovalWillAppear": "Zur Genehmigung gesendet — die Freigabe erscheint in der Liste, sobald {{names}} sie geprüft haben",
      "selectRole": "Rolle auswählen",
      "selectUnit": "Einheit auswählen",
      "rolesLoadError": "Rollen konnten nicht geladen werden",
      "unitsLoadError": "Einheiten konnten nicht geladen werden",
      "noRoles": "Keine Rollen verfügbar",
      "noUnits": "Keine Einheiten verfügbar",
      "error": {
        "roleRequired": "Rolle auswählen",
        "unitRequired": "Einheit auswählen"
      },
      "visibility": "Sichtbarkeit",
      "pendingError": "Ausstehende Freigaben konnten nicht geladen werden."
    },
    "tabs": {
      "documents": "Dokumente",
      "approvals": "Genehmigungen"
    },
    "detail": {
      "backToList": "Zurück zu den Dokumenten",
      "title": "Dokument",
      "openSource": "Quelle öffnen",
      "download": "Herunterladen",
      "notReady": "Datei verfügbar, sobald die Verarbeitung abgeschlossen ist.",
      "metadata": "Metadaten",
      "filename": "Dateiname",
      "mimeType": "MIME",
      "sourceType": "Quellentyp",
      "sourceId": "Quelle",
      "chunkCount": "Abschnitte",
      "createdAt": "Erstellt",
      "updatedAt": "Aktualisiert",
      "scopeTarget": "Geltungsbereich",
      "owner": "Eigentümer",
      "versions": "Versionen",
      "versionsEmpty": "Für dieses Dokument ist keine Versionsgeschichte erfasst.",
      "versionsUnavailable": "Die Versionsgeschichte konnte nicht geladen werden.",
      "versionNo": "v{{no}}"
    }
  },
  "errors": {
    "notFound": "Seite nicht gefunden",
    "accessDenied": "Sie haben keinen Zugriff auf diese Ressource oder sie existiert nicht mehr. Bitte prüfen Sie, ob Sie mit dem richtigen Konto angemeldet sind, oder wenden Sie sich an den Eigentümer.",
    "resourceNotFound": "Diese Ressource ist nicht mehr verfügbar.",
    "connection": "Server nicht erreichbar. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "serverFault": "Bei uns ist etwas schiefgelaufen. Bitte versuchen Sie es erneut.",
    "configLoadFailed": "Konfiguration konnte nicht geladen werden.",
    "backendUnreachable": "Fehler: Backend nicht erreichbar",
    "unexpectedError": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie, die Seite neu zu laden.",
    "reloadPage": "Seite neu laden",
    "goHome": "Zur Startseite"
  },
  "health": {
    "checking": "Verbindung wird geprüft...",
    "connecting": "Verbinde mit Server...",
    "starting": "Server startet...",
    "initializing": "App wird initialisiert...",
    "ready": "Bereit",
    "connected": "Verbunden",
    "disconnected": "Server nicht erreichbar",
    "retrying": "Verbindung wird erneut versucht...",
    "online": "Online",
    "offline": "Offline",
    "unknown": "Unbekannt"
  },
  "sse": {
    "liveUpdatesDisabled": "Live-Updates nicht verfügbar. Zum Neuladen tippen.",
    "schemaOutOfDate": "Live-Updates sind nicht verfügbar, weil diese App-Version veraltet ist. Bitte neu laden."
  },
  "confidence": {
    "high": "Verifizierte Quellen",
    "medium": "Quelleninfo",
    "low": "Information prüfen",
    "showReasoning": "Quellendetails anzeigen",
    "sourceCount": "{{count}} Quelle",
    "sourceCount_other": "{{count}} Quellen",
    "topScore": "Beste Übereinstimmung",
    "justify": "Warum dieses Vertrauensniveau?",
    "justifyPrompt": "Bitte begründe dein Vertrauensniveau für diese Antwort."
  },
  "carePlan": {
    "title": "Behandlungsplan",
    "homeTitle": "Behandlungspläne",
    "patientLabelAria": "Patient",
    "version": "Version {{version}}",
    "copyLink": "Link kopieren",
    "linkCopied": "Kopiert",
    "daySelector": "Tag",
    "addIntervention": "Intervention hinzufügen",
    "interventionDetails": "Interventionsdetails",
    "nothingPlanned": "Nichts geplant",
    "unassigned": "Nicht zugewiesen",
    "durationMinutes": "{{minutes}} Min.",
    "fieldDay": "Tag",
    "fieldTime": "Zeit",
    "fieldDuration": "Minuten",
    "fieldTitle": "Was geplant ist",
    "fieldTitlePlaceholder": "Kurztitel…",
    "fieldAssignee": "Durchgeführt von",
    "saving": "Speichern…",
    "retime": "Verschieben",
    "remove": "Entfernen",
    "noDisciplines": "Für diese Organisation sind noch keine klinischen Rollen definiert.",
    "noDisciplinesHint": "Ein Behandlungsplan wird pro Disziplin geplant, und eine Disziplin ist eine Rolle der Organisation. Bitte eine Administratorin, sie anzulegen.",
    "conflictRemoved": "Jemand anderes hat diese Intervention entfernt. Das Board zeigt jetzt den aktuellen Plan.",
    "commandFailed": "Die Änderung wurde nicht gespeichert. Bitte erneut versuchen.",
    "addIncomplete": "Gib der Intervention einen Titel, eine Zeit und eine Dauer.",
    "retimeIncomplete": "Gib der Intervention eine Zeit und eine Dauer.",
    "readFailed": "Dieser Behandlungsplan konnte nicht gelesen werden.",
    "chatPlaceholder": "Anweisungen an den Agenten…",
    "caseloadFailed": "Die Patientenliste konnte nicht gelesen werden.",
    "emptyCaseload": "Es sind keine Patientinnen aufgenommen.",
    "emptyCaseloadHint": "Ein Behandlungsplan gehört zu einem Aufenthalt. Nimm eine Patientin auf, um ihre Woche zu planen.",
    "conversationUnresolved": "Dieses Gespräch konnte nicht geöffnet werden.",
    "conversationHasNoStay": "Dieses Gespräch bezieht sich nicht auf eine aufgenommene Patientin, daher gibt es keinen Behandlungsplan zum Öffnen.",
    "faceNeedsPatient": "Ein Behandlungsplan gehört zu einer Patientin. Öffne ihn von der Station aus.",
    "stayUnresolved": "Der Aufenthalt dieser Patientin konnte nicht gelesen werden.",
    "patientNotAdmitted": "Diese Patientin ist nicht aufgenommen, daher gibt es keinen Aufenthalt zu planen.",
    "executionInProgress": "Läuft",
    "executionCompleted": "Erledigt",
    "executionCancelled": "Abgesagt",
    "executionMissed": "Ausgefallen",
    "executionUnavailable": "Was bereits erledigt wurde, konnte nicht gelesen werden. Diese Woche zeigt nur den Plan."
  },
  "roster": {
    "homeTitle": "Dienstplan",
    "newRoster": "Neuer Dienstplan",
    "untitled": "Unbenannter Dienstplan",
    "emptyHomeTitle": "Noch keine Dienstpläne",
    "emptyTitle": "Noch keine Dienste",
    "nurseColumn": "Pflegekraft",
    "daySelector": "Tag",
    "offDuty": "Frei",
    "share": "Teilen",
    "shareFallbackTitle": "Dienstplan",
    "sharedByViewOnly": "Geteilt von {{author}} · nur Ansicht",
    "viewOnly": "Nur Ansicht",
    "emptyViewerHint": "Die planende Person hat noch keine Dienste erfasst.",
    "myRosters": "Meine Dienstpläne",
    "sharedWithMe": "Mit mir geteilt",
    "sharedChip": "Geteilt",
    "byAuthor": "von {{author}}",
    "editFailed": "Änderung konnte nicht gespeichert werden. Bitte erneut versuchen.",
    "optimizing": "Troi optimiert…",
    "load_one": "{{count}} Dienst",
    "load_other": "{{count}} Dienste",
    "group": {
      "other": "Weitere"
    },
    "team": {
      "none": "Für diese Station sind noch keine Teammitglieder erfasst.",
      "loadError": "Das Stationsteam konnte nicht geladen werden."
    },
    "horizon": {
      "week": "Woche",
      "twoWeeks": "2 Wochen",
      "month": "Monat",
      "prev": "Vorheriger Zeitraum",
      "next": "Nächster Zeitraum",
      "days": "{{count}} Tage"
    },
    "status": {
      "updating": "aktualisiert…",
      "occurrencesUnavailable": "Dienstnamen und was gearbeitet wurde, konnten nicht gelesen werden; die Zellen zeigen nur ihren Code"
    },
    "cell": {
      "change": "Dienst für {{nurse}} ändern"
    },
    "picker": {
      "clear": "Löschen (frei)"
    },
    "empty": {
      "scope": "{{count}} Tage · {{range}}",
      "create": "Dienstplan erstellen"
    },
    "troi": {
      "title": "Troi fragen",
      "open": "Troi fragen",
      "hint": "Beschreiben Sie eine Änderung in Worten – z. B. «gib Anna das Wochenende frei». Troi überträgt sie auf das Board.",
      "placeholder": "Troi bitten, den Dienstplan anzupassen…"
    }
  },
  "triples": {
    "relatedResources": "Verwandte Ressourcen",
    "openProtocol": "Protokoll öffnen",
    "startProtocol": "Protokoll starten",
    "notYetWired": "Noch nicht verknüpft",
    "notYetWiredToast": "Diese Ressource ist noch nicht verknüpft.",
    "unavailable": "Verwandte Ressourcen nicht verfügbar",
    "unavailableHint": "Verwandte Ressourcen konnten für diese Antwort nicht geladen werden. Bitte versuchen Sie es gleich nochmal.",
    "runner": {
      "description": "Protokoll Schritt für Schritt durchführen",
      "loadFailed": "Protokoll konnte nicht geladen werden.",
      "stepFailed": "Schritt konnte nicht ausgeführt werden.",
      "retry": "Erneut versuchen",
      "done": "Fertig",
      "backToStart": "Zurück zum Anfang",
      "errorCodes": {
        "protocolRunFailed": "Protokollausführung fehlgeschlagen",
        "protocolRunInternal": "Interner Fehler bei der Protokollausführung"
      }
    }
  },
  "compatibility": {
    "homeTitle": "Y-Site-Kompatibilität",
    "subtitle": "Y-Site-Beurteilung",
    "loading": "Matrix wird geladen …",
    "parseError": "Das Kompatibilitätsergebnis konnte nicht gelesen werden.",
    "newCheck": "Neue Prüfung",
    "untitled": "Unbenannte Prüfung",
    "emptyHomeTitle": "Noch keine Prüfungen",
    "emptyHomeDescription": "Öffnen Sie die Y-Site-Matrix, um zu prüfen, ob zwei Medikamente gemeinsam infundiert werden können",
    "datasetLabel": "Datensatz",
    "pairsCount": "{{count}} Paare",
    "validUntil": "gültig bis",
    "search": {
      "placeholder": "Medikament suchen — Name, ATC, SNOMED …",
      "clear": "Suche löschen",
      "noResults": "Kein Medikament passt zu „{{query}}“.",
      "offMatrix": "„{{query}}“ wird in den Schweizer Medikamentendaten nachgeschlagen."
    },
    "legend": {
      "title": "Legende",
      "ok": "Kompatibel",
      "warn": "Spülen",
      "bad": "Inkompatibel",
      "muted": "Keine Daten"
    },
    "toneFilter": {
      "groupLabel": "Beurteilungstöne anzeigen",
      "toggleOn": "Zellen „{{tone}}“ ausblenden",
      "toggleOff": "Zellen „{{tone}}“ anzeigen",
      "showAll": "Alle anzeigen",
      "allHidden": "Alle Töne ausgeblendet — Legendenchip antippen, um Zellen zurückzuholen."
    },
    "tabs": {
      "aria": "Kompatibilitätsansichten",
      "matrix": "Matrix",
      "carriers": "Trägerlösungen",
      "separate": "Separate Verabreichung"
    },
    "matrix": {
      "title": "Kompatibilitätsmatrix",
      "self": "Gleiches Medikament",
      "noData": "Keine Daten",
      "ariaCell": "{{a}} mit {{b}}: {{verdict}}"
    },
    "carriers": {
      "title": "Trägerlösungs-Kompatibilität",
      "empty": "Keine Trägerlösungs-Daten in dieser Matrix.",
      "noEntry": "Kein Eintrag"
    },
    "separate": {
      "title": "Medikamente zur separaten Verabreichung",
      "emptyTitle": "Keine Medikamente in dieser Matrix erfordern separate Verabreichung.",
      "selectAria": "{{drug}} — {{verdict}}"
    },
    "verdicts": {
      "compatible_same_lumen": "Kompatibel — über ein Lumen gemeinsam verabreichen",
      "compatible_with_all_carriers": "Kompatibel mit allen Standard-Trägerlösungen",
      "requires_line_flush": "Leitung zwischen den Medikamenten spülen",
      "incompatible": "Inkompatibel — nicht gemeinsam verabreichen",
      "no_data": "Keine Daten"
    },
    "derivedNote": "Abgeleitete Beurteilung — nicht direkt in der Quellmatrix verifiziert.",
    "selfPairNote": "Gleiches Medikament auf beiden Achsen — Y-Site-Selbstmischung ist nicht aussagekräftig.",
    "panel": {
      "verdictTitle": "Y-Site-Beurteilung",
      "atc": "ATC",
      "emptyTitle": "Wählen Sie ein Medikament",
      "emptyHint": "Zelle für eine Y-Site-Beurteilung wählen, oder einen Medikamentennamen für die Übersicht.",
      "close": "Detailspalte ausblenden",
      "expand": "Detailspalte einblenden",
      "overlayTitle": "Medikamentendetails",
      "resizeHandle": "Detailspalte verbreitern oder schmaler ziehen",
      "drugInfoTitle": "Arzneimittelinformation"
    },
    "medication": {
      "loading": "Medikamentendaten werden geladen…",
      "error": "Medikamentendaten konnten nicht geladen werden. Suche anpassen, um es erneut zu versuchen.",
      "notFound": "In keiner Medikamentendatenbank gefunden.",
      "ingredients": "Wirkstoffe",
      "fachinfo": "Fachinformation",
      "showMore": "Vollständige Informationen ({{count}})",
      "showLess": "Weniger anzeigen",
      "sourceLabel": "Quelle: {{source}}",
      "tier": {
        "internal": "Spital-Arzneimittelliste",
        "national": "Swissmedic (SAI)",
        "international": "NHS dm+d (UK)"
      }
    },
    "pairPicker": {
      "slotA": "Medikament A",
      "slotB": "Medikament B",
      "pick": "{{slot}} wählen",
      "pickShort": "Medikament wählen",
      "change": "{{slot}} ändern",
      "clear": "{{slot}} entfernen",
      "prompt": "Zwei Medikamente wählen für die Y-Site-Beurteilung.",
      "noResults": "Kein Medikament passt zur Suche."
    },
    "notice": {
      "noData": "Keine Daten — manuelle Prüfung nötig",
      "institution_not_registered": "Institution nicht für Kompatibilitätsabfragen registriert.",
      "drug_not_recognized": "Medikament wurde nicht erkannt.",
      "pair_not_in_matrix": "Diese Kombination ist nicht in der Matrix dieser Institution."
    }
  },
  "patients": {
    "title": "Patientinnen und Patienten",
    "attributes": {
      "pattern_hint": "Format: {{pattern}}",
      "ward": "Station",
      "bed": "Bett",
      "room": "Zimmer",
      "unit": "Einheit",
      "admission_ref": "Aufnahme-Ref.",
      "age": "Alter",
      "glasgow": "Glasgow Coma Scale",
      "mobility": "Mobilität",
      "main_diagnosis": "Hauptdiagnose",
      "resuscitation_status": "Reanimationsstatus",
      "coding_status": "Kodierungsstatus"
    },
    "register": {
      "title": "Patient registrieren",
      "labelPreview": "Vorschau",
      "wardLoadError": "Einheitenliste konnte nicht geladen werden — für die Registrierung ist eine Einheit erforderlich.",
      "wardPlaceholder": "Einheit auswählen",
      "submit": "Registrieren",
      "submitting": "Wird registriert...",
      "configUnavailable": "Konfiguration wird geladen...",
      "error": "Patient konnte nicht registriert werden.",
      "admissionLink": {
        "title": "Aufnahme-Verknüpfung",
        "explanation": "Der echte Aufnahme-Identifikator für diese Station. Verknüpft diesen Patienten mit dem KIS-Fall — wird nach der Registrierung nur noch über eine protokollierte Einsicht angezeigt.",
        "tokenLabel": "Aufnahme-Referenz",
        "tokenExplanation": "Diese Referenz ist jetzt der sichtbare Aufnahme-Verweis des Patienten. Notieren Sie sie bei Bedarf — sie wird hier nicht erneut angezeigt.",
        "continue": "Weiter"
      },
      "needAnyAttribute": "Geben Sie mindestens ein Merkmal ein, damit der Patient identifizierbar ist.",
      "justRegistered": "{{patient}} erfasst",
      "batchCount_one": "{{count}} erfasst",
      "batchCount_other": "{{count}} erfasst",
      "moreFields": "Weitere Angaben",
      "done": "Fertig",
      "submitNext": "Nächsten erfassen",
      "save": "Speichern",
      "staleWrite": "Jemand anderes hat diese Patientin oder diesen Patienten während Ihrer Bearbeitung geändert. Das Formular zeigt jetzt den gespeicherten Stand — übernehmen Sie Ihre Änderung erneut und speichern Sie.",
      "revisionUnavailable": "Der aktuelle Stand dieses Datensatzes konnte nicht gelesen werden und lässt sich deshalb noch nicht speichern.",
      "schemaUnavailable": "Die Felder der Einheit dieser Patientin oder dieses Patienten konnten nicht geladen werden.",
      "pickUnitFirst": "Wählen Sie eine Einheit, um die dort erfassten Felder zu sehen."
    },
    "admissionLink": {
      "fields": {
        "case_number": "Fallnummer (KIS)"
      }
    },
    "list": {
      "stale": "Wird aktualisiert...",
      "empty": {
        "title": "Noch keine Patientinnen und Patienten",
        "description": "Registrieren Sie einen Patienten, um zu beginnen."
      },
      "loadError": {
        "title": "Liste konnte nicht geladen werden.",
        "retry": "Erneut versuchen"
      }
    },
    "assign": {
      "title": "Patient zuweisen",
      "action": "Patient zuweisen",
      "current": "Aktuelle Zuweisung",
      "choose": "Patient auswählen",
      "unassign": "Zuweisung entfernen",
      "unknownPatient": "Unbekannter Patient",
      "error": "Sitzung konnte nicht zugewiesen werden."
    },
    "unassign": {
      "error": "Zuweisung konnte nicht entfernt werden."
    }
  },
  "patientAdmin": {
    "homeTitle": "Patientenverwaltung",
    "subtitle": "Stationszensus",
    "list": {
      "title": "Patientinnen und Patienten",
      "addNew": "Neuen Patienten erfassen",
      "loadError": {
        "title": "Patientinnen und Patienten konnten nicht geladen werden.",
        "retry": "Erneut versuchen"
      },
      "empty": {
        "title": "Noch keine Patientinnen und Patienten",
        "description": "Registrieren Sie einen Patienten, um zu beginnen."
      },
      "showDischarged": "Entlassene anzeigen"
    },
    "detail": {
      "selectPrompt": "Wählen Sie einen Patienten aus, um den Aufenthalt zu sehen.",
      "currentPlacement": "Aktuelle Platzierung",
      "unit": "Einheit",
      "noActiveStay": "Aktuell nicht aufgenommen",
      "stayHistory": "Aufenthaltsverlauf",
      "stale": "Wird aktualisiert...",
      "noHistory": "Noch keine Aufenthalte erfasst.",
      "noHistoryDescription": "Aufnahmen und Verlegungen erscheinen hier.",
      "loadError": {
        "title": "Aufenthaltsverlauf konnte nicht geladen werden.",
        "retry": "Erneut versuchen"
      },
      "class": "Klasse",
      "status": "Status",
      "admittedAt": "Aufgenommen",
      "dischargedAt": "Entlassen",
      "disposition": "Entlassungsart",
      "dispositionsUnavailable": "Entlassungsarten sind momentan nicht verfügbar. Bitte versuchen Sie es in Kürze erneut.",
      "responsibleService": "Zuständiger Dienst",
      "timeline": "Platzierungsereignisse",
      "attributesTitle": "Attribute",
      "awaitingCaseNumber": "Keine Fallnummer",
      "noAttributes": "Keine Attribute erfasst.",
      "codenameExplanation": "Automatisch generiertes Pseudonym, abgeleitet aus der Patientenreferenz — es wird kein Name gespeichert.",
      "admittedToday": "heute aufgenommen ({{at}})",
      "admittedSince_one": "aufgenommen seit 1 Tag ({{at}})",
      "admittedSince_other": "aufgenommen seit {{count}} Tagen ({{at}})",
      "notInList": "Dieser Patient ist nicht in der aktuellen Liste",
      "notInListDescription": "Möglicherweise entlassen — aktivieren Sie «Entlassene anzeigen»."
    },
    "overview": {
      "totalPatients": "Registrierte Patientinnen und Patienten",
      "otherWards": "+{{count}} weitere",
      "unavailable": "Zensus derzeit nicht verfügbar"
    },
    "actions": {
      "admit": "Aufnehmen",
      "transfer": "Verlegen",
      "discharge": "Entlassen",
      "cancel": "Abbrechen",
      "continue": "Weiter",
      "confirmAdmit": "In Einheit aufnehmen",
      "confirmTransfer": "In Einheit verlegen",
      "confirmTransferPrompt": "{{patient}} nach {{unit}} verlegen?",
      "confirmDischarge": "Patient entlassen",
      "confirmDischargePrompt": "{{patient}} entlassen — {{disposition}}?",
      "chooseUnit": "Einheit auswählen",
      "chooseDisposition": "Entlassungsart auswählen",
      "submitting": "Wird gespeichert…",
      "editAttributes": "Attribute bearbeiten"
    },
    "admissionRef": {
      "title": "Aufnahme-Verknüpfung",
      "loadError": "Verknüpfungsstatus konnte nicht geladen werden.",
      "unlinkedHint": "Diese Aufnahme-Referenz ist noch nicht mit einem KIS-Fall verknüpft.",
      "linkedHint": "Mit einem KIS-Fall verknüpft.",
      "linkNow": "Jetzt verknüpfen",
      "reveal": "Aufnahme-Verknüpfung einsehen",
      "linkTitle": "Aufnahme-Referenz verknüpfen",
      "linkExplanation": "Geben Sie den echten Aufnahme-Identifikator für diese Station ein. Dies verknüpft die Aufnahme-Referenz des Patienten mit dem KIS-Fall.",
      "linkSubmit": "Verknüpfung speichern",
      "linkError": "Die Aufnahme-Verknüpfung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
      "revealTitle": "Aufnahme-Verknüpfung einsehen",
      "revealDescription": "Die Einsicht dieser Verknüpfung wird im Audit-Trail protokolliert.",
      "reasonLabel": "Grund für den Zugriff",
      "reasonPlaceholder": "Grund auswählen",
      "reasonsUnavailable": "Die Gründe für die Einsicht sind derzeit nicht verfügbar. Bitte versuchen Sie es in Kürze erneut.",
      "reasons": {
        "care_handover": "Übergabe",
        "billing_query": "Abrechnungsanfrage",
        "kis_reconciliation": "KIS-Abgleich",
        "other": "Sonstiges"
      },
      "invalidReasonCode": "Wählen Sie einen gültigen Grund.",
      "justificationLabel": "Begründung",
      "justificationPlaceholder": "Warum Sie jetzt Zugriff benötigen",
      "notFound": "Diese Aufnahme-Verknüpfung ist nicht verfügbar.",
      "revealFailed": "Die Aufnahme-Verknüpfung konnte nicht eingesehen werden. Bitte versuchen Sie es erneut.",
      "confirm": "Einsehen",
      "revealing": "Wird eingesehen…",
      "resultTitle": "Aufnahme-Verknüpfung",
      "resultWarning": "Diese Angaben werden nur einmal angezeigt und nicht in dieser Sitzung gespeichert.",
      "done": "Fertig"
    },
    "class": {
      "inpatient": "Stationär",
      "emergency": "Notfall",
      "observation": "Überwachung",
      "outpatient": "Ambulant"
    },
    "status": {
      "in_progress": "Laufend",
      "discharged": "Entlassen",
      "cancelled": "Storniert",
      "not_admitted": "Nicht aufgenommen"
    },
    "disposition": {
      "home": "Nach Hause",
      "transfer": "Verlegt",
      "deceased": "Verstorben",
      "against_advice": "Gegen ärztlichen Rat"
    },
    "eventType": {
      "admit": "Aufgenommen",
      "transfer": "Verlegt",
      "discharge": "Entlassen",
      "cancel_admit": "Aufnahme storniert",
      "cancel_transfer": "Verlegung storniert",
      "cancel_discharge": "Entlassung storniert"
    },
    "errors": {
      "noActiveEncounter": "Dieser Patient hat keinen laufenden Aufenthalt. Zuerst aufnehmen.",
      "encounterInProgress": "Dieser Patient hat bereits einen laufenden Aufenthalt.",
      "patientMoved": "Der Patient wurde inzwischen verlegt. Aktuelle Einheit prüfen und erneut versuchen.",
      "patientReAdmitted": "Der Standort des Patienten hat sich geändert. Aktuelle Einheit prüfen und erneut versuchen.",
      "admitSuperseded": "Der Patient wurde gleichzeitig entlassen. Aktuellen Status prüfen.",
      "placementRequired": "Wählen Sie eine Einheit für diesen Patienten.",
      "locationHasChildren": "Diese Einheit hat Untereinheiten. Wählen Sie eine konkrete Station oder ein Bett.",
      "invalidClass": "Wählen Sie eine gültige Klasse.",
      "invalidDisposition": "Wählen Sie eine gültige Entlassungsart.",
      "admitFailed": "Patient konnte nicht aufgenommen werden. Bitte erneut versuchen.",
      "transferFailed": "Patient konnte nicht verlegt werden. Bitte erneut versuchen.",
      "dischargeFailed": "Patient konnte nicht entlassen werden. Bitte erneut versuchen.",
      "updateAttributesFailed": "Attribute konnten nicht gespeichert werden. Bitte erneut versuchen."
    },
    "loading": "Laden…"
  },
  "shifts": {
    "title": "Schichten",
    "patient": {
      "label": "Patient",
      "placeholder": "Patient auswählen"
    },
    "nurse": {
      "placeholder": "Name eingeben",
      "unknown": "Unbekannt",
      "free": "frei",
      "patientLoad_one": "{{count}} Pat.",
      "patientLoad_other": "{{count}} Pat."
    },
    "handover": {
      "action": "Übergeben",
      "title": "Patient übergeben",
      "curation": "Was mit übergeben wird",
      "curationHint": "Markiere die Gespräche, die deine Kollegin zuerst sehen soll.",
      "noteLabel": "Übergabenotiz",
      "notePlaceholder": "Was deine Kollegin wissen sollte…",
      "start": "Übergabe starten",
      "starting": "Übergabe wird gestartet…",
      "startHint": "Deine Kollegin wird zum Rapport eingeladen. Die Verantwortung bleibt bei dir, bis der Patient neu zugeteilt ist.",
      "startError": "Die Übergabe konnte nicht gestartet werden.",
      "flaggedIntro": "Für die Übergabe markiert:",
      "defaultSeed": "Ich übergebe diesen Patienten. Bitte um kurzen Rapport-Entwurf.",
      "sessionTitle": "Übergabe {{patient}}",
      "picker": {
        "onShift": "Auf Schicht",
        "loadError": "Konnte nicht laden, wer im Dienst ist.",
        "empty": "Keine Kolleg:innen im Dienst auf deiner Station.",
        "searchOther": "Andere Pflegeperson suchen"
      }
    },
    "journey": {
      "title": "Dein Weg durch die Schicht",
      "youAreHere": "Du bist hier",
      "start": "Schicht starten",
      "takeover": "Patienten übernehmen",
      "patientCount_one": "{{count}} Patient:in in deiner Betreuung",
      "patientCount_other": "{{count}} Patient:innen in deiner Betreuung",
      "handover": "Übergeben",
      "rapportRunning_one": "Rapport läuft für {{count}} Patient:in",
      "rapportRunning_other": "Rapport läuft für {{count}} Patient:innen",
      "handoverHint": "Gegen Ende deiner Schicht, pro Patient:in.",
      "end": "Schicht beenden"
    },
    "loadError": "Deine Schicht konnte nicht geladen werden.",
    "offDuty": {
      "title": "Du bist nicht im Dienst",
      "description": "Starte deine Schicht, um deine Patient:innen zu betreuen."
    },
    "onDuty": {
      "title": "Im Dienst",
      "patientCount_one": "{{count}} Patient:in",
      "patientCount_other": "{{count}} Patient:innen"
    },
    "myPatients": "Meine Patient:innen",
    "noPatients": {
      "title": "Noch keine Patient:innen",
      "description": "Füge eine Patient:in hinzu, um die Betreuung zu beginnen."
    },
    "endAssignment": {
      "action": "Beenden",
      "error": "Die Zuweisung konnte nicht beendet werden."
    },
    "addPatient": {
      "title": "Patient:in hinzufügen",
      "submitting": "Wird hinzugefügt…",
      "submit": "Patient:in hinzufügen",
      "none": {
        "title": "Keine weiteren Patient:innen",
        "description": "Alle registrierten Patient:innen sind bereits in deiner Schicht."
      }
    },
    "end": {
      "submitting": "Wird beendet…",
      "submit": "Schicht beenden",
      "error": "Die Schicht konnte nicht beendet werden."
    },
    "assign": {
      "error": "Der Patient konnte nicht zugewiesen werden."
    }
  },
  "sharing": {
    "roleLabel": "Zugriffsstufe",
    "searchTruncated": "Zeige {{shown}} von {{total}} — Suche verfeinern",
    "searchFailed": "Suche fehlgeschlagen. Bitte erneut versuchen.",
    "error": {
      "lastOwner": "Der letzte Besitzer kann nicht entfernt werden. Übertragen Sie zuerst die Eigentümerschaft."
    }
  },
  "approvals": {
    "title": "Genehmigungen",
    "backHome": "Zurück zur Startseite",
    "empty": "Keine ausstehenden Genehmigungen.",
    "sections": {
      "documents": "Dokumente",
      "units": "Einheiten"
    }
  },
  "colleague": {
    "title": "Kollegen mit Erfahrung",
    "detailsAriaLabel": "Details zu {{name}}",
    "yearsAbbrev": "{{years}}J"
  },
  "offline": {
    "viewCached": "Gespeicherte Antworten",
    "cacheTitle": "Zwischengespeicherte Antworten",
    "cacheDescription": "Ihre letzten 10 Fragen und Antworten, verfügbar auch ohne Internetverbindung.",
    "cacheCount": "{{count}} gespeicherte Antwort",
    "cacheCount_other": "{{count}} gespeicherte Antworten",
    "clearCache": "Cache leeren",
    "emptyCache": "Noch keine Antworten zwischengespeichert",
    "citationCount": "{{count}} Quelle",
    "citationCount_other": "{{count}} Quellen"
  },
  "time": {
    "justNow": "gerade eben",
    "minutesAgo": "{{count}} Min",
    "minutesAgo_other": "{{count}} Min",
    "hoursAgo": "{{count}} Std",
    "hoursAgo_other": "{{count}} Std",
    "daysAgo": "{{count}} Tag",
    "daysAgo_other": "{{count}} Tage"
  },
  "footer": {
    "disclaimer": "Dokumentation und Richtliniensuche für Pflegefachpersonen."
  },
  "feedback": {
    "failedDescription": "Ihr Feedback konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    "helpful": "Hilfreiche Antwort",
    "unhelpful": "Nicht hilfreiche Antwort",
    "viewBookmark": "Lesezeichen ansehen",
    "saveBookmark": "Als Lesezeichen speichern"
  },
  "elicitation": {
    "error": {
      "fieldRequired": "Dieses Feld ist erforderlich.",
      "required": "Bitte füllen Sie alle Pflichtfelder aus.",
      "submit": "Senden fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "network": "Netzwerkfehler. Bitte versuchen Sie es erneut."
    },
    "pleaseSelect": "Bitte auswählen…",
    "decline": "Ablehnen"
  },
  "uiAction": {
    "error": {
      "generic": "Aktion fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "notSent": "Aktion konnte nicht gesendet werden"
    },
    "externalLink": {
      "title": "Externen Link öffnen?",
      "body": "Dies öffnet {{origin}} in einem neuen Tab."
    }
  },
  "skills": {
    "header": {
      "title": "Mein Wissensprofil"
    },
    "loading": {
      "ariaLabel": "Wird geladen"
    },
    "error": {
      "loadFailed": "Ihre Fähigkeiten konnten nicht geladen werden.",
      "unknownError": "Unbekannter Fehler.",
      "retry": "Erneut versuchen"
    },
    "section": {
      "declare": "Fähigkeit angeben",
      "view": "Ansicht"
    },
    "view": {
      "list": "Liste",
      "map": "Wissenskarte",
      "switcherAriaLabel": "Ansicht wählen"
    },
    "form": {
      "labelPlaceholder": "Womit haben Sie gearbeitet? z. B. Sepsis-Management",
      "labelAriaLabel": "Fähigkeit in eigenen Worten",
      "addButton": "Hinzufügen",
      "catalogueAriaLabel": "Fähigkeit aus dem Katalog",
      "catalogueNone": "Keine Katalogfähigkeit",
      "catalogueLoading": "Katalog wird geladen…",
      "catalogueFailed": "Der Fähigkeitskatalog konnte nicht geladen werden. Sie können weiterhin eine Fähigkeit in eigenen Worten angeben.",
      "catalogueNotConfigured": "Für diese Installation ist kein Fähigkeitskatalog hinterlegt. Geben Sie Ihre Fähigkeit in eigenen Worten an."
    },
    "proposed": {
      "title": "Vom Kurator vorgeschlagen",
      "empty": "Keine Vorschläge. Der Kurator wertet Ihre Sitzungen aus — neue Vorschläge erscheinen hier."
    },
    "proposal": {
      "accept": "Übernehmen",
      "reject": "Ablehnen",
      "acceptAriaLabel": "Übernehmen: {{label}}",
      "rejectAriaLabel": "Ablehnen: {{label}}",
      "reasoningLoading": "Begründung wird geladen…",
      "reasoningFailed": "Die Begründung konnte nicht geladen werden. Bitte erst laden, dann entscheiden.",
      "reasoningMissing": "Zu diesem Vorschlag liegt keine Begründung vor."
    },
    "pending": {
      "title": "Woran Sie arbeiten",
      "empty": "Nichts, worauf Sie derzeit hinarbeiten.",
      "target": "Ziel bis {{due}} · {{basis}}",
      "qualificationStarts": "Zertifikat gültig ab {{date}}",
      "recordsLoading": "Einträge werden geladen…",
      "recordsFailed": "Die Einträge dazu konnten nicht geladen werden."
    },
    "targetBasis": {
      "declared": "durch eigene Angabe",
      "qualified": "durch Bestätigung des Betriebs"
    },
    "held": {
      "title": "Meine Fähigkeiten",
      "empty": "Noch nichts erfasst. Geben Sie oben an, womit Sie gearbeitet haben.",
      "publish": "Veröffentlichen",
      "unpublish": "Zurückziehen",
      "publishAriaLabel": "Veröffentlichen: {{label}}",
      "unpublishAriaLabel": "Zurückziehen: {{label}}",
      "showEndorsements": "Rückmeldungen von Kolleg:innen"
    },
    "rejected": {
      "title": "Abgelehnt"
    },
    "basis": {
      "declaration": "Selbst angegeben",
      "endorsement": "Von Kolleg:innen",
      "qualification": "Vom Betrieb bestätigt",
      "attempt": "Aus Lernmodulen",
      "proposal": "Vorgeschlagen",
      "target": "Ziel"
    },
    "badges": {
      "validUntil": "Gültig bis {{date}}"
    },
    "endorsements": {
      "empty": "Noch keine Rückmeldungen von Kolleg:innen.",
      "loadFailed": "Die Rückmeldungen konnten nicht geladen werden.",
      "colleague": "Kolleg:in",
      "noComment": "Bestätigt, ohne Kommentar."
    },
    "map": {
      "clinicalConcepts": "Klinische Konzepte",
      "furtherSkills": "Weitere Fähigkeiten",
      "empty": "Noch nichts hier."
    },
    "toast": {
      "saveFailed": "Konnte nicht gespeichert werden",
      "saveFailedDesc": "Bitte erneut versuchen.",
      "staleVersion": "Inzwischen geändert",
      "staleVersionDesc": "Diese Fähigkeit hat sich geändert, seit Sie sie geöffnet haben. Der aktuelle Stand wird angezeigt."
    }
  },
  "targets": {
    "due": "Bis {{date}}",
    "overdue": "Fällig war {{date}}",
    "examDate": "Prüfung {{date}}",
    "state": {
      "achieved": "Erreicht",
      "dropped": "Verworfen"
    }
  },
  "agent": {
    "chat": {
      "name": "Chat"
    },
    "care-planner": {
      "name": "Patientenplan"
    },
    "compatibility": {
      "name": "Kompatibilität"
    },
    "protocols": {
      "name": "Prozessanalyse"
    },
    "knowledge-profile": {
      "name": "Wissensprofil"
    },
    "roster": {
      "name": "Dienstplan"
    },
    "patient-admin": {
      "name": "Patientenverwaltung"
    },
    "learn": {
      "name": "Lernen"
    },
    "mentor": {
      "name": "Ausbildung"
    },
    "access": {
      "name": "Mein Zugriff"
    },
    "team-access": {
      "name": "Team-Zugriff"
    },
    "allocation": {
      "name": "Patientenzuteilung"
    },
    "handover": {
      "name": "Rapport"
    }
  },
  "conversation": {
    "state": {
      "active": "Aktiv",
      "done": "Erledigt",
      "needsReview": "Zu prüfen"
    }
  },
  "admin": {
    "analytics": {
      "dash": {
        "overview": "Übersicht",
        "latency": "Latenz",
        "usage": "Nutzung",
        "competencies": "Team-Kompetenzen",
        "training": "Training",
        "loadError": "Dashboard konnte nicht geladen werden — bitte erneut versuchen.",
        "slowLoad": "Dauert länger als üblich — das Analyse-Backend startet möglicherweise gerade."
      }
    },
    "dashboard": {
      "title": "Admin-Dashboard",
      "previewTooltip": "Ihre schreibgeschützte Admin-Vorschau endet in {{count}} Tag.",
      "previewTooltip_other": "Ihre schreibgeschützte Admin-Vorschau endet in {{count}} Tagen.",
      "previewBadge": "Admin-Vorschau · noch {{count}} Tag",
      "previewBadge_other": "Admin-Vorschau · noch {{count}} Tage",
      "tabs": {
        "queries": "Anfragen",
        "clusters": "Cluster",
        "sessions": "Sitzungen",
        "feedback": "Feedback",
        "reported-errors": "Gemeldete Fehler",
        "approvals": "Freigaben",
        "organisation": "Organisation",
        "permissions": "Berechtigungen"
      },
      "tabHelp": {
        "queries": "Alle Anfrageprotokolle durchsuchen. Auf eine Anfrage klicken, um die ganze Sitzung mit System-Prompt und Tool-Aufrufen zu sehen.",
        "clusters": "Anfragen nach Zeit, Rolle, Erfahrung oder Institution gruppieren, um Muster zu erkennen.",
        "sessions": "Vollständige Chat-Sitzungen mit Nachrichten, Zitaten, Konfidenz und System-Prompt ansehen.",
        "feedback": "Alles Nutzerfeedback (Daumen hoch/runter). Klicken, um den ganzen Sitzungskontext zu sehen.",
        "reported-errors": "Clientseitige Fehler, auf die Nutzer „Melden“ getippt haben oder die einen Bildschirm zum Absturz brachten – das Ziel der Melden-Aktion. Neueste zuerst.",
        "approvals": "Institutionelle Dokumente zur Prüfung freigeben oder ablehnen. Dokumente sind bis zur Freigabe in Quarantäne.",
        "organisation": "Standorthierarchie, Rollen, wer wo arbeitet und welche Patienten in welcher Einheit liegen verwalten.",
        "permissions": "Erteilen oder entziehen, wer auf Plattform-Befugnisse, jeden Admin-Bereich und jeden Agenten zugreifen kann – für eine Person oder eine ganze Rolle."
      }
    },
    "queryExplorer": {
      "loadError": "Anfragen konnten nicht geladen werden — bitte erneut versuchen.",
      "searchPlaceholder": "Anfragen suchen...",
      "prev": "Zurück",
      "next": "Weiter",
      "pagePrefix": "S.",
      "citations": "{{count}} Zitat",
      "citations_other": "{{count}} Zitate",
      "empty": "Keine Anfragen gefunden",
      "selectPrompt": "Eine Anfrage wählen, um die ganze Sitzung zu sehen",
      "sessionLoadError": "Sitzung konnte nicht geladen werden",
      "feedbackType": {
        "positive": "positiv",
        "negative": "negativ",
        "incorrect": "falsch",
        "missing": "fehlend",
        "other": "sonstige"
      }
    },
    "userSelect": {
      "searchPlaceholder": "Nutzer suchen...",
      "clearFilter": "Nutzerfilter zurücksetzen",
      "clear": "Zurücksetzen",
      "loadFailed": "Nutzer konnten nicht geladen werden.",
      "noResults": "Keine Nutzer gefunden"
    },
    "feedbackExplorer": {
      "timeRange": {
        "day": "Letzte 24 Std.",
        "week": "Letzte 7 Tage",
        "month": "Letzte 30 Tage"
      },
      "filter": {
        "all": "Alle",
        "positive": "Positiv",
        "negative": "Negativ",
        "incorrect": "Falsch",
        "missing": "Fehlend",
        "other": "Sonstige"
      },
      "entriesLabel": "Feedback-Einträge",
      "positiveCount": "{{count}} positiv",
      "negativeCount": "{{count}} negativ",
      "loadError": "Feedback konnte nicht geladen werden",
      "empty": "Keine Feedback-Einträge für diesen Zeitraum",
      "noQueryText": "Kein Anfragetext",
      "untitledSession": "Sitzung ohne Titel",
      "showingEntries": "{{shown}} von {{total}} Einträgen werden angezeigt",
      "selectPrompt": "Einen Feedback-Eintrag wählen, um die ganze Sitzung zu sehen"
    },
    "queryClusters": {
      "loadError": "Anfrage-Cluster konnten nicht geladen werden",
      "dimension": {
        "time": "Zeit",
        "role": "Rolle",
        "experience": "Erfahrung",
        "specialisation": "Spezialisierung",
        "institution": "Institution"
      },
      "timeRange": {
        "day": "Tag",
        "week": "Woche",
        "month": "Monat"
      },
      "viewCards": "Karten",
      "viewChart": "Diagramm",
      "empty": "Keine Anfrage-Cluster für diese Dimension gefunden",
      "hideExamples": "Beispiele ausblenden",
      "showExamples": "{{count}} Beispiel anzeigen",
      "showExamples_other": "{{count}} Beispiele anzeigen"
    },
    "documentApproval": {
      "serviceUnavailable": "Der Wissensdienst ist in dieser Umgebung nicht verfügbar.",
      "serviceUnavailableHint": "Für die Dokumentenfreigabe muss der knowledge-service laufen.",
      "loadError": "Ausstehende Dokumente konnten nicht geladen werden",
      "empty": "Keine Dokumente zur Freigabe ausstehend",
      "columnTitle": "Titel",
      "columnCategory": "Kategorie",
      "columnStatus": "Status",
      "columnUploaded": "Hochgeladen",
      "columnChunks": "Chunks",
      "columnActions": "Aktionen",
      "deleteConfirmPrompt": "Endgültig löschen?",
      "confirm": "Bestätigen",
      "approving": "Wird freigegeben...",
      "approve": "Freigeben",
      "reject": "Ablehnen",
      "showingDocuments": "{{shown}} von {{total}} Dokumenten werden angezeigt"
    },
    "sessionMonitor": {
      "loadError": "Sitzungen konnten nicht geladen werden",
      "empty": "Keine Sitzungen gefunden",
      "selectPrompt": "Sitzung auswählen, um Nachrichten anzuzeigen"
    },
    "sessionDetail": {
      "loadErrorTitle": "Sitzung konnte nicht geladen werden",
      "loadErrorBody": "Beim Laden der Sitzung ist ein Fehler aufgetreten. Bitte versuchen Sie es gleich noch einmal.",
      "selectPrompt": "Sitzung auswählen, um Nachrichten anzuzeigen",
      "untitled": "Unbenannte Sitzung",
      "messageCount": "{{count}} Nachricht",
      "messageCount_other": "{{count}} Nachrichten",
      "noMessages": "Keine Nachrichten in dieser Sitzung",
      "toolTracesUnavailable": "Tool-Traces nicht verfügbar",
      "toolCalls": "{{tool}} ×{{calls}}",
      "imageAttached": "Bild angehängt"
    },
    "reportedErrors": {
      "intro": "Fehler, die Nutzer über «Melden» gemeldet haben oder die einen Bildschirm zum Absturz brachten — neueste zuerst.",
      "refresh": "Aktualisieren",
      "loadError": "Gemeldete Fehler konnten nicht geladen werden",
      "empty": "Noch keine gemeldeten Fehler.",
      "reportedBy": "Gemeldet von {{name}}",
      "reporterUnknown": "Melder unbekannt",
      "componentStack": "Komponenten-Stack",
      "detail": {
        "request": "Aufruf",
        "status": "HTTP-Status",
        "errorCode": "Fehlercode",
        "origin": "Auslöser",
        "screen": "Bildschirm",
        "time": "Zeitpunkt",
        "reportId": "Melde-ID",
        "requestId": "Request-ID (Server-Log)",
        "noTrace": "Keine weiteren technischen Angaben — diese Meldung betraf keinen API-Aufruf.",
        "session": "Sitzung",
        "turn": "Turn (Seq)",
        "agent": "Agent"
      },
      "triage": {
        "owner": "Zuständig",
        "unassigned": "Niemand zugewiesen",
        "unassign": "Zuweisung aufheben",
        "status": "Status",
        "assignTo": "Zuweisen an",
        "pick": "Auswählen …",
        "agents": "Agenten",
        "channels": "Kanäle",
        "history": "Verlauf",
        "thread": "Antworten",
        "noReplies": "Noch keine Antworten.",
        "reply": "Antworten",
        "replyPlaceholder": "Antwort schreiben …",
        "loadError": "Triage konnte nicht geladen werden.",
        "eventFailed": "Aktion konnte nicht gespeichert werden.",
        "replyFailed": "Antwort konnte nicht gesendet werden.",
        "unassignedEvent": "Zuweisung aufgehoben",
        "statuses": {
          "open": "Offen",
          "in_progress": "In Bearbeitung",
          "done": "Erledigt",
          "cancelled": "Abgebrochen"
        }
      },
      "consoleLog": "Letzte Browser-Logeinträge",
      "diagnostics": {
        "title": "Unter der Haube",
        "turnRecords": "Turn-Datensätze",
        "prompt": "Gerenderter Prompt (gepinnte Version)",
        "promptNote": "Jetzt gerendert, für Ihre Tools; der Teil der zurückgehaltenen Tools kann vom Turn der meldenden Person abweichen.",
        "unavailable": "Serverseitiger Kontext nicht verfügbar: {{reason}}",
        "sessionReadError": "Sitzung konnte nicht gelesen werden: {{reason}}"
      }
    }
  },
  "allocation": {
    "assign": "Zuweisen",
    "assigning": "Wird zugewiesen…",
    "notOnShift": "Nicht mehr im Dienst.",
    "error": "Zuweisung fehlgeschlagen — bitte erneut versuchen.",
    "board": {
      "title": "Schichtstart",
      "progress": "{{done}} von {{total}} zugeteilt",
      "complete": "Alle Patienten zugeteilt — die Station ist übergeben.",
      "nobodyOnShift": "Noch niemand im Dienst — Patienten können zugeteilt werden, sobald eine Pflegefachperson ihre Schicht beginnt.",
      "proposalHint": "Vorschlag: {{nurse}}",
      "assign": "Zuweisen",
      "change": "Ändern",
      "load_one": "{{count}} Patient",
      "load_other": "{{count}} Patienten",
      "room": "Zimmer {{room}}",
      "noRoom": "Ohne Zimmer",
      "roomsList": "Zimmer {{rooms}}",
      "assignRoom": "Ganzes Zimmer zuweisen",
      "assignRoomTo": "Ganzes Zimmer zuweisen an…",
      "split": "geteilt",
      "spread": "Über mehrere Zimmer verteilt",
      "partialAssign": "{{failed}} von {{total}} Betten konnten nicht zugewiesen werden.",
      "noPatients": "Keine Patienten auf der Station.",
      "loadError": "Stationszuteilung konnte nicht geladen werden.",
      "noWard": "Deinem Profil ist noch keine Einheit zugeordnet.",
      "chatPlaceholder": "Verteilungsvorschlag anfragen…",
      "progressLabel": "Fortschritt der Patientenzuteilung"
    }
  },
  "sessions": {
    "sharing": {
      "expiry": "Läuft ab (optional)",
      "expiryHint": "Zeitlich befristete Freigaben gelten nur für Lesezugriff."
    }
  },
  "learn": {
    "homeTitle": "Lernen",
    "resume": {
      "label": "Weitermachen, wo du aufgehört hast",
      "untitled": "Deine Unterhaltung"
    },
    "targets": {
      "title": "Woran ich arbeite",
      "loadError": "Deine Ziele konnten nicht geladen werden.",
      "empty": {
        "title": "Noch keine Ziele",
        "description": "Deine vorgesetzte Person kann dir ein Ziel auf eine Fähigkeit setzen — frag den Assistenten, woran du als Nächstes arbeiten sollst."
      }
    },
    "recommended": {
      "title": "Für dich empfohlen",
      "loadError": "Der Quiz-Katalog konnte nicht geladen werden.",
      "empty": {
        "title": "Noch nichts zu tun",
        "description": "Sobald eines deiner Ziele ein veröffentlichtes Quiz nennt, erscheint es hier."
      },
      "becauseTarget": "Für dein Ziel: {{title}}"
    },
    "session": {
      "loading": "Lädt…"
    },
    "board": {
      "chatPlaceholder": "Frag zu deinem Lernen…"
    },
    "actions": {
      "exam": {
        "label": "Prüfung steht an",
        "submit": "Ziel setzen",
        "dateLabel": "Prüfungsdatum",
        "request": "Ich habe am {{date}} eine Prüfung zu {{topic}}. Setz mir ein Ziel auf die Fähigkeit {{topic}} mit diesem Prüfungsdatum und erstelle mir privates Übungsmaterial dazu."
      },
      "practice": {
        "label": "Frag mich ab",
        "submit": "Erstellen",
        "request": "Erstelle mir ein privates Übungsquiz zu {{topic}}, gestützt auf unsere Richtlinien."
      },
      "topicPlaceholder": "Zu welchem Thema?",
      "topicLabel": "Thema"
    }
  },
  "mentor": {
    "board": {
      "title": "Mentor",
      "switchUnit": "Einheit wechseln",
      "newTarget": "Neues Ziel",
      "summary": "{{trainees}} Auszubildende · {{openTargets}} offen · {{achievedTargets}} erreicht",
      "loadError": "Das Mentor-Board konnte nicht geladen werden.",
      "chatPlaceholder": "Mentor-Assistent fragen…",
      "noTargets": "Noch keine Ziele gesetzt.",
      "targetsHeading": "Ziele",
      "targetCounts": "{{open}} offen · {{achieved}} erreicht",
      "showDetail": "Details anzeigen",
      "hideDetail": "Details ausblenden",
      "notFramed": "Dieses Gespräch ist noch keiner Einheit zugeordnet.",
      "roster": {
        "title": "Auszubildende",
        "empty": {
          "title": "Noch keine Auszubildenden",
          "description": "Auszubildende erscheinen hier, sobald sie dieser Einheit beitreten."
        }
      }
    },
    "targets": {
      "trainee": "Auszubildende Person",
      "traineePlaceholder": "Person auswählen…",
      "skill": "Fähigkeit",
      "skillPlaceholder": "Fähigkeit auswählen…",
      "skillsEmpty": "Der Fähigkeitskatalog ist leer, es lässt sich also noch kein Ziel setzen.",
      "skillsError": "Der Fähigkeitskatalog konnte nicht geladen werden.",
      "dueDate": "Bis wann",
      "drop": "Verwerfen",
      "dropping": "Wird verworfen…",
      "save": "Ziel setzen",
      "saving": "Wird gespeichert…"
    },
    "quiz": {
      "sectionTitle": "Quiz",
      "emptyTitle": "Noch keine Quiz",
      "empty": "Bitte die Assistenz, aus einem Dokument deiner Einheit ein Quiz zu erzeugen, oder modelliere eines im Protokoll-Studio.",
      "listErrorTitle": "Die Quiz konnten nicht geladen werden",
      "listError": "Der Quiz-Katalog konnte nicht geladen werden.",
      "statusDraft": "Entwurf",
      "statusPublished": "Veröffentlicht",
      "statusInReview": "In Prüfung",
      "statusArchived": "Archiviert"
    },
    "curricula": {
      "assignError": "Das Curriculum konnte nicht zugewiesen werden. Bitte erneut versuchen.",
      "unassignError": "Das Curriculum konnte nicht entfernt werden. Bitte erneut versuchen."
    }
  }
}
